/* lua.js generated code 0.3.0 */
 //-----------------------------------------------------------------------
//  Class include: CommonEffect, FallingStar, Firebolt
//-----------------------------------------------------------------------
// NOT USED
// require("hecore/display/ArmatureNode")
require("clover/animation/config/CommonEffectConfig")
require("clover/const/QualityConst")
var kCharacterAnimationTime = 1 / 26
var kLineAnimationTime = 1 / 30
var kRad3Ang = -180 / 3.1415926
var numberLineParticles = 0
CommonEffect = {}
CommonEffect.reset = function () {
    numberLineParticles = 0
}
var bubbleAnimation = null
CommonEffect.getBubbleAnimation = function () {
    if (bubbleAnimation == null) {
        var frames = SpriteUtil.buildFrames("line_bubble_%04d.png", 0, 16)
        bubbleAnimation = SpriteUtil.buildAnimate(frames, 1 / 40)
        bubbleAnimation.retain()
    }
    // WARN: maybe multi result
    return bubbleAnimation.clone()
}
CommonEffect.cleanBubbleAnimation = function () {
    if (bubbleAnimation) {
        bubbleAnimation.release()
        bubbleAnimation = null
    }
}
CommonEffect.buildLineEffect = function (batchNode, onlyRight) {
    var node = cc.Sprite.create()
    // if (batchNode) {
    //     node.setTexture(batchNode.getTexture())
    // }
    // local function buildLightLine(direction)
    // 	local sprite = cc.Sprite:createWithSpriteFrameName("speed_line0000.png")
    // 	sprite:setScale(0.1 * direction)
    // 	sprite:setOpacity(0)
    // 	sprite:setAnchorPoint(ccp(0.3,0.5))
    // 	local lineAnimationTime = 0.25
    // 	local function onLightAnimationEnd()
    // 		if sprite and not sprite.isDisposed then
    // 			sprite:stopAllActions()
    // 			sprite:runAction(cc.Spawn:create(cc.MoveBy:create(0.2, ccp(80*direction, 0)), cc.FadeOut:create(0.2)))
    // 		end
    // 	end 
    // 	local array = LuaArray:create()
    // 	array:addObject(cc.ScaleTo:create(0.2, 1*direction))
    // 	array:addObject(cc.FadeIn:create(0.1))
    // 	array:addObject(cc.MoveBy:create(0.4, ccp(100*direction, 0)))
    // 	array:addObject(cc.Sequence:create(cc.DelayTime:create(0.4), cc.CallFunc:create(onLightAnimationEnd)))
    // 	array:addObject(cc.Sequence:create(cc.DelayTime:create(0.3), cc.CallFunc:create(onLightAnimationEnd)))
    // 	sprite:runAction(cc.Spawn:create(array:toLuaArray()))
    // 	return sprite
    // end
    function buildLightLine2(direction) {
        var sprite = cc.Sprite.createWithSpriteFrameName("line_back.png")
        sprite.setScaleX(direction)
        sprite.setOpacity(0)
        sprite.setAnchorPoint(ccp(0.65, 0.5))
        var lineAnimationTime = 0.25
        function onLightAnimationEnd() {
            if (sprite && !sprite.isDisposed) {
                sprite.stopAllActions()
                sprite.runAction(cc.Spawn.create(cc.MoveBy.create(0.15, ccp(170 * direction, 0)), cc.FadeOut.create(0.15), cc.ScaleTo.create(0.15, 8 * direction, 0.3)))
            }
        }
        var array = LuaArray.create()
        array.addObject(cc.ScaleTo.create(0.3, 12 * direction, 1.2))
        array.addObject(cc.FadeIn.create(0.1))
        array.addObject(cc.MoveBy.create(0.3, ccp(765 * direction, 0)))
        array.addObject(cc.Sequence.create(cc.DelayTime.create(0.3), cc.CallFunc.create(onLightAnimationEnd)))
        sprite.runAction(cc.Spawn.create(array.toLuaArray()))
        return sprite
    }
    // function createStars() {
    //     var maxStar = 10
    //     var $limit17 = maxStar
    //     for (var k = 1; k <= $limit17; k += 1) {
    //         var sprite = ObjectPool.getInstance().get("LineStar")
    //         sprite.setScale(math.random())
    //         sprite.setOpacity(0)
    //         var x = (k - 5) * 50
    //         var index = k % 2 === 0 && 1 || -1
    //         var y = math.random() * 20 * index
    //         sprite.setPosition(ccp(x, y))
    //         var actionList = LuaArray.create()
    //         actionList.addObject(cc.FadeIn.create(0.1))
    //         actionList.addObject(cc.DelayTime.create(0.5))
    //         actionList.addObject(cc.FadeOut.create(0.2))
    //         actionList.addObject(cc.CallFunc.create(function () {
    //             sprite.removeFromParent(true)
    //             ObjectPool.getInstance().collect("LineStar", sprite)
    //         }))
    //         sprite.runAction(cc.Spawn.create(cc.Sequence.create(actionList.toLuaArray()), cc.RotateBy.create(2, 720)))
    //         node.addChild(sprite)
    //     }
    // }
    function onLightAnimationBegin() {
        var right = buildLightLine2(1)
        right.setPosition(55, 0)
        node.addChild(right, 0)
        if (!onlyRight) {
            var left = buildLightLine2(-1)
            left.setPosition(-55, 0)
            node.addChild(left, 0)
        }
    }
    // function createFog() {
    //     for (var i = 1; i <= 20; i += 1) {
    //         var sprite = ObjectPool.getInstance().get("LineFog")
    //         sprite.setOpacity(0)
    //         sprite.setPosition(ccp((i > 10 && (10 - i) || i) * 55, 0))
    //         var actionList = LuaArray.create()
    //         actionList.addObject(cc.FadeIn.create(0.03 * (10 - i)))
    //         actionList.addObject(cc.DelayTime.create(0.1))
    //         actionList.addObject(cc.FadeOut.create(0.1))
    //         actionList.addObject(cc.CallFunc.create(function () {
    //             sprite.removeFromParent(true)
    //             ObjectPool.getInstance().collect("LineFog", sprite)
    //         }))
    //         sprite.runAction(cc.Sequence.create(actionList.toLuaArray()))
    //         node.addChild(sprite)
    //     }
    //     for (var i = 1; i <= 10; i += 1) {
    //         var destroySprite = ObjectPool.getInstance().get("LineBubble")
    //         destroySprite.setRotation((i > 5 && -1 || 1) * 90)
    //         destroySprite.setPosition(ccp((i > 5 && (5 - i) || i) * 155, 0))
    //         var animate = CommonEffect.getBubbleAnimation()
    //         function onFinish() {
    //             destroySprite.removeFromParent(true)
    //             ObjectPool.getInstance().collect("LineBubble", destroySprite)
    //         }
    //         destroySprite.play(animate, (i > 5 && -(5 - i) || i) * 0.08, 1, onFinish)
    //         node.addChild(destroySprite)
    //     }
    // }
    function onAnimationFinished() {
        node.removeFromParent(true)
        numberLineParticles = numberLineParticles - 1
        if (numberLineParticles < 0) {
            numberLineParticles = 0
        }
    }
    var array = LuaArray.create()
    array.addObject(cc.DelayTime.create(0.1))
    array.addObject(cc.CallFunc.create(onLightAnimationBegin))
    // var displayParticles = true
    // if (numberLineParticles > Quality.kLineEffectMaxNum) {
    //     displayParticles = false
    //     if (math.random() < 0.35) {
    //         displayParticles = true
    //     }
    // }
    // if (_G.__use_low_effect || cc.Director.getInstance().getAvgFrameRate() < Quality.kFPSGuardLine) {
    //     displayParticles = false
    // }
    // if (displayParticles) {
    //     numberLineParticles = numberLineParticles + 1
    //     createStars()
    //     array.addObject(cc.CallFunc.create(createFog))
    // }
    array.addObject(cc.DelayTime.create(1.2))
    array.addObject(cc.CallFunc.create(onAnimationFinished))
    node.runAction(cc.Sequence.create(array.toLuaArray()))
    return node
}
CommonEffect.buildLineWater = function () {
    // var destroySprite
    // var frames
    // var animate
    // destroySprite = cc.Sprite.createWithSpriteFrameName("line_water_effect_0000.png")
    // frames = SpriteUtil.buildFrames("line_water_effect_%04d.png", 0, 23)
    // animate = SpriteUtil.buildAnimate(frames, 1 / 40)
    // function onRepeatFinishCallback_DestroyEffect() {
    //     destroySprite.removeFromParent(true)
    // }
    // destroySprite.play(animate, 0, 1, onRepeatFinishCallback_DestroyEffect)
    // return destroySprite
    return cc.Sprite.create()
}
CommonEffect.buildLineCross = function () {
    let self = this
    let sprite = cc.Sprite.createWithSpriteFrameName("line_cross_effect_0000.png")
    sprite.setScale(0.339)
    sprite.setVisible(false)
    sprite.runAction(cc.Sequence.create(cc.DelayTime.create(0), cc.Show.create(), cc.ScaleTo.create(4 / 30, 1.07), cc.DelayTime.create(11 / 30), cc.RemoveSelf.create(true)))
    return sprite
}
var kSpecialEffectName = table(
    "good_icon",
    "great_icon",
    "excellent_icon",
    "amazing_icon",
    "unbelievable_icon"
)
var kSpecialEffectTitle = table(
    "good",
    "great",
    "excellent",
    "amazing",
    "unbelievable"
)
CommonEffect.buildSpecialTitle = function (effectType, callback) {
    effectType = effectType || 1
    var animName = string.format("gameScene/%s.png", kSpecialEffectTitle[effectType])
    var [offsetx, offsety] = [0, 0]
    var sprite = cc.Sprite.createWithSpriteFrameName(animName)
    sprite.setAnchorPoint(cc.p(0.5, 0.5))
    sprite.setPosition(offsetx, offsety)
    sprite.setOpacity(0)
    sprite.setScale(0.22222900390625, 0.22222900390625)
    var action = cc.Sequence.create(cc.EaseSineIn.create(cc.Spawn.create(cc.ScaleTo.create(0.1667, 1.3, 1.3), cc.FadeTo.create(0.1667, 255))), cc.EaseSineOut.create(cc.ScaleTo.create(0.1333, 0.9, 0.9)), cc.ScaleTo.create(0.1333, 1, 1), cc.DelayTime.create(0.4), cc.Spawn.create(cc.ScaleTo.create(0.2, 1.6, 1.6), cc.FadeTo.create(0.2, 0)), cc.CallFunc.create(callback))
    sprite.runAction(action)
    return sprite
}
CommonEffect.buildSpecialStars = function (parent) {
    var particalName = "gameScene/star_blink.png"
    function getStarOne() {
        var node = cc.Node.create()
        var sprite = cc.Sprite.createWithSpriteFrameName(particalName)
        var sequence = cc.Sequence.create(cc.Spawn.create(cc.ScaleTo.create(0.0833, 0.8036, 0.8036), cc.FadeTo.create(0.0833, 178.5)), cc.Spawn.create(cc.ScaleTo.create(0.0833, 1, 1), cc.FadeTo.create(0.0833, 255)))
        sprite.runAction(cc.RepeatForever.create(sequence))
        node.addChild(sprite)
        node.setCascadeOpacityEnabled(true)
        return node
    }
    function createPartical() {
        var [offsetx, offsety] = [64.2, -77.75]
        var sprite = getStarOne()
        sprite.setPosition(offsetx, offsety)
        sprite.setOpacity(0)
        sprite.setScale(1.1306)
        var action = cc.Sequence.create(cc.EaseSineOut.create(cc.FadeTo.create(0.1667, 255)), cc.DelayTime.create(0.6333), cc.Spawn.create(cc.MoveTo.create(0.2, cc.p(81.2, -184.75)), cc.FadeTo.create(0.2, 0)))
        sprite.runAction(action)
        parent.addChild(sprite)
        var [offsetx, offsety] = [-3.8000000000000007, 12.05]
        var sprite = getStarOne()
        sprite.setPosition(offsetx, offsety)
        sprite.setAnchorPoint(cc.p(0.5079, 0.4892))
        sprite.setOpacity(0)
        sprite.setScale(1.8, 1.8)
        var action = cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.MoveTo.create(0.1667, cc.p(-11.6, 38.7)), cc.FadeTo.create(0.1667, 255))), cc.MoveTo.create(0.6333, cc.p(-17.8, 59.95)), cc.Spawn.create(cc.MoveTo.create(0.2, cc.p(-62.8, 155.95)), cc.FadeTo.create(0.2, 0)))
        sprite.runAction(action)
        parent.addChild(sprite)
        var [offsetx, offsety] = [-125.80000000000001, -16.199999999999992]
        var sprite = getStarOne()
        sprite.setPosition(offsetx, offsety)
        sprite.setAnchorPoint(cc.p(0.5072, 0.4891))
        sprite.setOpacity(0)
        sprite.setScale(1.1306, 1.1306)
        var action = cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.MoveTo.create(0.1667, cc.p(-149.75, -42.85)), cc.FadeTo.create(0.1667, 255))), cc.MoveTo.create(0.6333, cc.p(-168.8, -64.2)), cc.Spawn.create(cc.MoveTo.create(0.2, cc.p(-270.8, -128.2)), cc.FadeTo.create(0.2, 0)))
        sprite.runAction(action)
        parent.addChild(sprite)
        var [offsetx, offsety] = [122.2, -13.6]
        var sprite = getStarOne()
        sprite.setPosition(offsetx, offsety)
        sprite.setAnchorPoint(cc.p(0.5072, 0.4891))
        sprite.setOpacity(0)
        sprite.setScale(1.1306, 1.1306)
        var action = cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.MoveTo.create(0.1667, cc.p(165.55, -31.65)), cc.FadeTo.create(0.1667, 255))), cc.MoveTo.create(0.6333, cc.p(200.2, -46.05)), cc.Spawn.create(cc.MoveTo.create(0.2, cc.p(270.2, -155.05)), cc.FadeTo.create(0.2, 0)))
        sprite.runAction(action)
        parent.addChild(sprite)
        var [offsetx, offsety] = [-133.8, 11.95000000000002]
        var sprite = getStarOne()
        sprite.setPosition(offsetx, offsety)
        sprite.setAnchorPoint(cc.p(0.5072, 0.4891))
        sprite.setOpacity(0)
        sprite.setScale(1.1306, 1.1306)
        var action = cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.MoveTo.create(0.1667, cc.p(-162.7, 23.6)), cc.FadeTo.create(0.1667, 255))), cc.MoveTo.create(0.6333, cc.p(-185.8, 32.95)), cc.Spawn.create(cc.MoveTo.create(0.2, cc.p(-260.8, 23.95)), cc.FadeTo.create(0.2, 0)))
        sprite.runAction(action)
        parent.addChild(sprite)
        var [offsetx, offsety] = [-64.80000000000001, -0.050000000000011126]
        var sprite = getStarOne()
        sprite.setPosition(offsetx, offsety)
        sprite.setAnchorPoint(cc.p(0.5079, 0.4892))
        sprite.setOpacity(0)
        sprite.setScale(1.8, 1.8)
        var action = cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.MoveTo.create(0.1667, cc.p(-74.25, -25.6)), cc.FadeTo.create(0.1667, 198.9))), cc.Spawn.create(cc.MoveTo.create(0.6333, cc.p(-81.8, -46.05)), cc.FadeTo.create(0.6333, 153)), cc.Spawn.create(cc.MoveTo.create(0.2, cc.p(-112.8, -196.05)), cc.FadeTo.create(0.2, 0)))
        sprite.runAction(action)
        parent.addChild(sprite)
        var [offsetx, offsety] = [90.2, 7.1]
        var sprite = getStarOne()
        sprite.setPosition(offsetx, offsety)
        sprite.setAnchorPoint(cc.p(0.5079, 0.4892))
        sprite.setOpacity(0)
        sprite.setScale(1.8, 1.8)
        var action = cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.MoveTo.create(0.1667, cc.p(117.4, 29.3)), cc.FadeTo.create(0.1667, 198.9))), cc.Spawn.create(cc.MoveTo.create(0.6333, cc.p(139.2, 46.95)), cc.FadeTo.create(0.6333, 153)), cc.Spawn.create(cc.MoveTo.create(0.2, cc.p(176.2, 90.95)), cc.FadeTo.create(0.2, 0)))
        sprite.runAction(action)
        parent.addChild(sprite)
    }
    createPartical()
}
CommonEffect.buildSpecialEffectTitle = function (effectType) {
    effectType = effectType || 1
    var node = cc.Node.create()
    function over() {
        node.removeFromParent(true)
    }
    var sp = CommonEffect.buildSpecialTitle(effectType, over)
    node.addChild(sp)
    if (effectType > 2) {
        CommonEffect.buildSpecialStars(node)
    }
    node.setPosition(display.center)
    return node
}
CommonEffect.buildBonusEffect = function () {
    var node = cc.Node.create()
    var layer = cc.LayerColor.create(cc.c4b(0, 0, 0, 255 * 0.3))
    layer.changeWidthAndHeight(display.width, display.height)
    layer.setOpacity(0)
    layer.setCascadeOpacityEnabled(true)
    layer.runAction(cc.Sequence.create(cc.FadeTo.create(7 / 30, 0.3 * 255), cc.DelayTime.create(1), cc.FadeOut.create(7 / 30)))
    layer.setPosition(-display.width / 2, -display.height / 2)
    node.addChild(layer)
    function createAnimation(fileName, callback) {
        // body
        var sp = cc.CSLoader.createNode(fileName)
        var actionTimeLine = cc.CSLoader.createTimeline(fileName)
        sp.runAction(actionTimeLine)
        node.addChild(sp)
        actionTimeLine.gotoFrameAndPlay(0, false)
        if (callback) {
            actionTimeLine.setLastFrameCallFunc(callback)
        }
    }
    function over() {
        node.removeFromParent(true)
    }
    createAnimation("cocos/gameScene_light.csb")
    createAnimation("cocos/bonus_racoon_show.csb")
    createAnimation("cocos/bonus_chick_show.csb")
    createAnimation("cocos/gameScene_bonustime_word.csb", over)
    node.setPosition(display.center)
    node.setScale(1.1)
    return node
}
CommonEffect.buildExplodeEffect = function () {
    CommonEffect.preLoadCommonEffectResource()
    var node = cc.Node.create()
    node.name = "explode"
    node.touchEnabled = false
    node.touchChildren = false
    node.setScale(ViewSizeUtil.getScale())
    var destroySprite = cc.Sprite.createWithSpriteFrameName("explode0000")
    node.addChild(destroySprite)
    var frames = SpriteUtil.buildFrames(node.name + "%04d", 0, 19)
    var animate = SpriteUtil.buildAnimate(frames, kCharacterAnimationTime)
    function onRepeatFinishCallback() { }
    destroySprite.play(animate, 0, 1, onRepeatFinishCallback)
    return node
}
// CommonEffect.buildGetPropLightAnimWithoutBg = function () {
//     var fps = 30
//     FrameLoader.loadImageWithPlist("flash/get_prop_bganim.plist")
//     var anim = cc.Node.create()
//     anim.lightBg1 = cc.Sprite.createWithSpriteFrameName("circleLight.png")
//     anim.lightBg1.setAnchorPoint(ccp(0.5, 0.5))
//     anim.lightBg1.setScale(0.6)
//     anim.addChild(anim.lightBg1)
//     anim.lightBg1.runAction(cc.Spawn.create(cc.ScaleTo.create(7 / fps, 1.08), cc.FadeTo.create(7 / fps, 0.6 * 255)))
//     anim.lightBg1.runAction(cc.RepeatForever.create(cc.RotateBy.create(0.1, 9)))
//     function createLight() {
//         var container = cc.Node.create()
//         container.setAnchorPoint(ccp(0.5, 0.5))
//         var opacity = 0.78 * 255
//         var sprite = cc.Sprite.createWithSpriteFrameName("circleLight2.png")
//         sprite.setAnchorPoint(ccp(0.5, 0.5))
//         sprite.setScale(0.88)
//         sprite.setOpacity(0.92 * opacity)
//         container.addChild(sprite)
//         var seq = LuaArray.create()
//         seq.addObject(cc.Spawn.create(cc.ScaleTo.create(17 / fps, 1.14), cc.FadeTo.create(17 / fps, opacity)))
//         seq.addObject(cc.Spawn.create(cc.ScaleTo.create(19 / fps, 0.88), cc.FadeTo.create(19 / fps, 0.92 * opacity)))
//         sprite.runAction(cc.RepeatForever.create(cc.Sequence.create(seq.toLuaArray())))
//         return container
//     }
//     function createStarAnim() {
//         var container = cc.Node.create()
//         container.setAnchorPoint(ccp(0.5, 0.5))
//         var starLight = cc.Sprite.createWithSpriteFrameName("star_light.png")
//         var star = cc.Sprite.createWithSpriteFrameName("star.png")
//         container.addChild(starLight)
//         container.addChild(star)
//         var lightAnim = cc.Spawn.create(cc.ScaleTo.create(10 / fps, 1), cc.FadeTo.create(10 / fps, 0.1 * 255))
//         function resetLight() {
//             starLight.setScale(0.5)
//             starLight.setOpacity(255)
//         }
//         resetLight()
//         var lightSeq = cc.Sequence.create(lightAnim, cc.CallFunc.create(resetLight))
//         starLight.runAction(cc.RepeatForever.create(lightSeq))
//         function resetStar() {
//             star.setOpacity(255)
//             star.setScale(0.94)
//         }
//         resetStar()
//         var spawnArr = LuaArray.create()
//         spawnArr.addObject(cc.RotateBy.create(10 / fps, 90))
//         spawnArr.addObject(cc.FadeTo.create(10 / fps, 0.1 * 255))
//         spawnArr.addObject(cc.ScaleTo.create(10 / fps, 1.22))
//         var starAnim = cc.Spawn.create(spawnArr.toLuaArray())
//         var starSeq = cc.Sequence.create(starAnim, cc.CallFunc.create(resetStar))
//         star.runAction(cc.RepeatForever.create(starSeq))
//         return container
//     }
//     anim.lightBg3 = createLight()
//     anim.lightBg3.setScale(0.85)
//     anim.addChild(anim.lightBg3)
//     anim.lightBg3.runAction(cc.ScaleTo.create(7 / fps, 1.4))
//     anim.lightBg2 = createLight()
//     anim.lightBg2.setScale(1.05)
//     anim.addChild(anim.lightBg2)
//     var ops = table(
//         [0, { x: -1, y: 1 }],
//         [0, { x: 1, y: 1 }],
//         [0, { x: 1, y: -1 }],
//         [0, { x: -1, y: -1 }]
//     )
//     for (var i = 1; i <= 14; i += 1) {
//         var star = createStarAnim()
//         var op = ops[i % 4 + 1]
//         var posX = (400 - math.random(400)) / 10 * op.x
//         var posY = (400 - math.random(400)) / 10 * op.y
//         var pos = ccp(posX, posY)
//         star.setPosition(pos)
//         star.setScale(0.4 + math.random(5) / 10)
//         var [deltaX, deltaY] = [0, 0]
//         var deltaDistance = (100 + math.random(50))
//         if (pos.x === 0 || pos.y === 0) {
//             if (pos.x === 0 && pos.y !== 0) {
//                 deltaY = deltaDistance
//             } else if (pos.y === 0 && pos.x !== 0) {
//                 deltaX = deltaDistance
//             } else {
//                 deltaX = math.random(deltaDistance)
//                 deltaY = Math.sqrt(deltaDistance * deltaDistance - deltaX * deltaX)
//             }
//             if (math.random(10) > 5) {
//                 deltaX = 0 - deltaX
//             }
//             if (math.random(10) > 5) {
//                 deltaY = 0 - deltaY
//             }
//         } else {
//             var a = Math.sqrt(pos.x * pos.x + pos.y * pos.y)
//             deltaX = deltaDistance * pos.x / a
//             deltaY = deltaDistance * pos.y / a
//         }
//         function onAnimFinished() {
//             star.removeFromParent(true)
//         }
//         var seq = LuaArray.create()
//         seq.addObject(cc.MoveBy.create(6 / fps, ccp(deltaX * 3 / 7, deltaY * 3 / 7)))
//         seq.addObject(cc.MoveBy.create(9 / fps, ccp(deltaX * 4 / 7, deltaY * 4 / 7)))
//         seq.addObject(cc.CallFunc.create(onAnimFinished))
//         star.runAction(cc.Sequence.create(seq.toLuaArray()))
//         anim.addChild(star)
//     }
//     return anim
// }
// CommonEffect.buildGetPropLightAnim = function (text) {
//     var anim = Layer.create()
//     anim.blackLayer = LayerColor.create()
//     var winSize = cc.Director.getInstance().getWinSize()
//     var blackBgScale = 1
//     var blackWidth = winSize.width * blackBgScale * 2
//     var blackHeight = winSize.height * blackBgScale
//     anim.blackLayer.changeWidthAndHeight(blackWidth, blackHeight)
//     anim.blackLayer.setPosition(ccp(-blackWidth / 2, -blackHeight / 2))
//     anim.blackLayer.setOpacity(150)
//     anim.addChild(anim.blackLayer)
//     var lightAnim = CommonEffect.buildGetPropLightAnimWithoutBg()
//     lightAnim.setScale(1.23)
//     anim.addChild(lightAnim)
//     var sequenceArr3 = LuaArray.create()
//     sequenceArr3.addObject(cc.DelayTime.create(2.5))
//     sequenceArr3.addObject(cc.FadeTo.create(0.3, 0))
//     function onAnimationFinished() {
//         anim.removeFromParent(true)
//     }
//     sequenceArr3.addObject(cc.CallFunc.create(onAnimationFinished))
//     anim.blackLayer.setTouchEnabled(true, 0, true)
//     anim.blackLayer.stopAllActions()
//     anim.blackLayer.runAction(cc.Sequence.create(sequenceArr3.toLuaArray()))
//     if (type(text) === "string") {
//         var label = cc.Label.createWithSystemFont(text, null, 30)
//         label.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
//         label.setAnchorPoint(ccp(0.5, 0.5))
//         label.setPosition(ccp(0, 180))
//         anim.addChild(label)
//     }
//     return anim
// }
CommonEffect.buildBloodNum = function (num) {
    var container = cc.Node.create()
    var node = cc.Node.create()
    var labs = table()
    var scale = Math.min(0.65 + Math.abs(num) / 3 * 0.1, 1)
    container.setScale(scale)
    var num = tostring(num)
    var wid = 0
    var hei = 0
    var $limit143 = $len(num)
    for (var i = 1; i <= $limit143; i += 1) {
        var lab = cc.Label.createWithBMFont("font/boss_blood.fnt", string.sub(num, i, i))
        lab.setPositionX(wid)
        node.addChild(lab)
        table.insert(labs, lab)
        wid = wid + lab.getContentSize().width
        hei = Math.max(lab.getContentSize().height, hei)
    }
    function call() {
        for (var k in labs) {
            var v = labs[k]
            var action_list = table()
            table.insert(action_list, cc.FadeOut.create(0.6))
            table.insert(action_list, cc.MoveBy.create(0.6, cc.p(0, -230)))
            table.insert(action_list, cc.RotateBy.create(0.6, 180))
            v.runAction(cc.Sequence.create(cc.DelayTime.create(0.1 * k), cc.Spawn.create(action_list)))
        }
    }
    var action_list = table()
    table.insert(action_list, cc.ScaleTo.create(0.15, scale))
    table.insert(action_list, cc.DelayTime.create(0.5))
    table.insert(action_list, cc.CallFunc.create(call))
    table.insert(action_list, cc.DelayTime.create(3))
    table.insert(action_list, cc.CallFunc.create(function () {
        container.removeFromParent(true)
    }))
    container.setScale(2 * scale)
    container.runAction(cc.Sequence.create(action_list))
    node.setPositionX(-wid / 2)
    container.addChild(node)
    return [container, wid]
}
// FallingStar ---------------------------------------------------------
FallingStar = xClass("FallingStar", cc.Layer)
FallingStar.prototype.buildUI = function (useWhiteColor) {
    var self = this
    //var textureKey = "fallingstar0000"
    //if (useWhiteColor) {
    //    textureKey = "fallingstar_white0000"
    //}
    let textureKey = "homeScene/fallingstar.png"
    if (useWhiteColor) {
        textureKey = "homeScene/fallingstar_white.png"
    }
    var sprite = cc.Sprite.createWithSpriteFrameName(textureKey)
    sprite.setAnchorPoint(ccp(0.5, 0.05))
    self.addChild(sprite)
    self.sprite = sprite
    // if (!_G.__use_low_effect) {
    //     var particle = cc.ParticleSystem.create("particle/falling_star.plist")
    //     particle.setPosition(ccp(0, 0))
    //     self.addChild(particle)
    // }
}
FallingStar.create = function (from, to, animationCallbackFunc, flyFinishedCallback, useWhiteColor, delay) {
    var ret = FallingStar.new()
    ret.buildUI(useWhiteColor)
    var timeSpend = ret.fly(from, to, animationCallbackFunc, flyFinishedCallback, delay)
    return [ret, timeSpend]
}
FallingStar.prototype.fly = function (from, to, animationCallbackFunc, flyFinishedCallback, delay) {
    var self = this
    var dx = to.x - from.x
    var dy = to.y - from.y
    var distance = dx * dx + dy * dy
    var visibleSize = cc.Director.getInstance().getVisibleSize()
    var visibleHeight = visibleSize.height
    var time = 1.5 * Math.sqrt(distance) / visibleHeight
    var angle = Math.atan2(dy, dx) * kRad3Ang
    function onAnimationFinished() {
        if (animationCallbackFunc != null) {
            animationCallbackFunc()
        }
        self.removeFromParent(true)
    }
    time = time * 0.7
    time = 0.3
    var delayTime = delay || 0
    self.time = time
    var halfTime = time * 0.5
    var fadeIn = cc.Spawn.create(cc.ScaleTo.create(halfTime * 1.5, 2, 1.3), cc.FadeIn.create(halfTime))
    var fadeOut = cc.Spawn.create(cc.ScaleTo.create(halfTime * 0.5, 0), cc.FadeOut.create(halfTime * 0.5))
    var sprite = self.sprite
    sprite.setRotation(angle - 90)
    sprite.setScale(0)
    sprite.setOpacity(0)
    sprite.runAction(cc.Sequence.create(cc.DelayTime.create(delayTime), fadeIn, fadeOut))
    var array = LuaArray.create()
    array.addObject(cc.DelayTime.create(delayTime))
    array.addObject(cc.EaseSineInOut.create(cc.MoveTo.create(time, to)))
    if (flyFinishedCallback != null) {
        array.addObject(cc.CallFunc.create(flyFinishedCallback))
    }
    array.addObject(cc.DelayTime.create(0.6))
    array.addObject(cc.CallFunc.create(onAnimationFinished))
    self.setPosition(from)
    self.runAction(cc.Sequence.create(array.toLuaArray()))
    return time + delayTime
}
// FourTileStar ---------------------------------------------------------
FourTileStar = xClass("FourTileStar", cc.Layer)
FourTileStar.prototype.buildUI = function () {
    var self = this
    var textureKey = "fourtile_combine_0012.png"
    var sprite = cc.Sprite.createWithSpriteFrameName(textureKey)
    self.addChild(sprite)
    self.sprite = sprite
    self.sprite.setVisible(false)
}
FourTileStar.create = function (from, to, center, flyFinishedCallback) {
    var ret = FourTileStar.new()
    ret.buildUI()
    var timeSpend = ret.fly(from, to, center, flyFinishedCallback)
    return [ret, timeSpend]
}
FourTileStar.prototype.fly = function (from, to, center, flyFinishedCallback) {
    var self = this
    from = center
    var dx = to.x - from.x
    var dy = to.y - from.y
    var distance = dx * dx + dy * dy
    var time = 1 * Math.sqrt(distance) / GamePlayConfig_Design_Height
    function startFly() {
        self.sprite.setVisible(true)
        var angle = -math.deg(Math.atan(dy / dx))
        self.sprite.setRotation(angle)
        function onAnimationFinished() {
            if (flyFinishedCallback != null) {
                flyFinishedCallback()
            }
            self.removeFromParent(true)
        }
        var actionList1 = table()
        table.insert(actionList1, cc.ScaleTo.create(time * 0.7, 2.2, 0.8))
        table.insert(actionList1, cc.ScaleTo.create(time * 0.3, 1, 1))
        var actionList3 = table()
        table.insert(actionList3, cc.Spawn.create(cc.Sequence.create(actionList1), cc.MoveTo.create(time, to)))
        table.insert(actionList3, cc.CallFunc.create(onAnimationFinished))
        self.sprite.runAction(cc.Sequence.create(actionList3))
        self.sprite.setPosition(from)
    }
    var destroySprite
    var frames
    var animate
    destroySprite = cc.Sprite.createWithSpriteFrameName("fourtile_combine_0000.png")
    destroySprite.setPosition(center.x, center.y)
    frames = SpriteUtil.buildFrames("fourtile_combine_%04d.png", 0, 14)
    animate = SpriteUtil.buildAnimate(frames, kCharacterAnimationTime)
    function onFinish() {
        destroySprite.removeFromParent(true)
        startFly()
    }
    destroySprite.play(animate, 0, 1, onFinish)
    self.addChild(destroySprite)
    return 14 * kCharacterAnimationTime + time
}
FishChangeToStoneEffect = xClass("FishChangeToStoneEffect", cc.Node)
FishChangeToStoneEffect.prototype.buildUI = function () {
    var self = this
    var sp = cc.Sprite.createWithSpriteFrameName("fish_lock_0000.png")
    self.addChild(sp)
    self.sp = sp
}
FishChangeToStoneEffect.create = function (from, to, animationCallbackFunc, flyFinishedCallback) {
    var ret = FishChangeToStoneEffect.new()
    ret.buildUI(useWhiteColor)
    ret.fly(from, to, animationCallbackFunc, flyFinishedCallback)
    return ret
}
FishChangeToStoneEffect.prototype.fly = function (from, to, animationCallbackFunc, flyFinishedCallback) {
    var self = this
    var dx = to.x - from.x
    var dy = to.y - from.y
    var distance = dx * dx + dy * dy
    var visibleSize = cc.Director.getInstance().getVisibleSize()
    var visibleHeight = visibleSize.height
    var time = 1.5 * Math.sqrt(distance) / visibleHeight
    var angle = Math.atan2(dy, dx) * kRad3Ang
    function onAnimationFinished() {
        if (animationCallbackFunc != null) {
            animationCallbackFunc()
        }
        self.removeFromParent(true)
    }
    self.sp.setScale(0.25)
    var actionList = table(
        [0, cc.Spawn.create(cc.MoveBy.create(0.2667, cc.p(0, 37.5)), cc.ScaleTo.create(0.2667, 1, 1))],
        [0, cc.Spawn.create(cc.MoveBy.create(0.1667, cc.p(0, 10)), cc.ScaleTo.create(0.1667, 0.8, 0.8))],
        [0, cc.Sequence.create(cc.Spawn.create(cc.ScaleTo.create(time * 0.5, 1.4), cc.ScaleTo.create(time * 0.5, 0.91)), cc.EaseSineIn.create(cc.MoveTo.create(time, to)))]
    )
    if (flyFinishedCallback != null) {
        table.insert(actionList, cc.CallFunc.create(flyFinishedCallback))
    }
    table.insert(actionList, cc.DelayTime.create(0.6))
    table.insert(actionList, cc.CallFunc.create(onAnimationFinished))
    self.sp.setPosition(from)
    self.sp.runAction(cc.Sequence.create(actionList))
}
// Firebolt ---------------------------------------------------------
Firebolt = xClass("Firebolt", cc.Layer)
Firebolt.prototype.buildUI = function () {
    var self = this
    //local glow = cc.Sprite:createWithSpriteFrameName("")
    var sprite = cc.Sprite.createWithSpriteFrameName("thunder_effect10000")
    sprite.setAnchorPoint(ccp(0.5, 0.05))
    self.addChild(sprite)
    self.sprite = sprite
    // if (!_G.__use_low_effect) {
    //     var particle = cc.ParticleSystemQuad.create("particle/falling_star.plist")
    //     particle.setPosition(ccp(0, 0))
    //     self.addChild(particle)
    // }
}
Firebolt.create = function (from, to, duration, animationCallbackFunc) {
    var ret = Firebolt.new()
    ret.buildUI()
    ret.fly(from, to, duration, animationCallbackFunc)
    return ret
}
Firebolt.prototype.fly = function (from, to, duration, animationCallbackFunc) {
    var self = this
    var dx = to.x - from.x
    var dy = to.y - from.y
    var distance = dx * dx + dy * dy
    var time = duration || 0.4
    var angle = Math.atan2(dy, dx) * kRad3Ang
    function onAnimationFinished() {
        if (animationCallbackFunc != null) {
            animationCallbackFunc()
        }
        self.removeFromParent(true)
    }
    var halfTime = time * 0.5
    var fadeIn = cc.Spawn.create(cc.ScaleTo.create(halfTime, 2, 1.5), cc.FadeIn.create(halfTime))
    var fadeOut = cc.Spawn.create(cc.ScaleTo.create(halfTime, 0), cc.FadeOut.create(halfTime))
    var sprite = self.sprite
    sprite.setRotation(angle - 90)
    sprite.setScale(0)
    sprite.setOpacity(0)
    sprite.runAction(cc.Sequence.create(fadeIn, fadeOut))
    var array = LuaArray.create()
    array.addObject(cc.EaseSineInOut.create(cc.MoveTo.create(time, to)))
    array.addObject(cc.DelayTime.create(0.1))
    array.addObject(cc.CallFunc.create(onAnimationFinished))
    self.setPosition(from)
    self.runAction(cc.Sequence.create(array.toLuaArray()))
}
Firebolt.createLightOnly = function (from, to, duration, animationCallbackFunc) {
    var sprite = cc.Sprite.createWithSpriteFrameName("thunder_effect_bird.png")
    var container = cc.SpriteBatchNode.createWithTexture(sprite.getTexture())
    sprite.setAnchorPoint(ccp(0.5, 0.05))
    var bird = cc.Sprite.createWithSpriteFrameName("bird_normal0000.png")
    var dx = to.x - from.x
    var dy = to.y - from.y
    var distance = dx * dx + dy * dy
    var time = duration || 0.4
    var angle = Math.atan2(dy, dx) * kRad3Ang
    function onLightAnimationEnd() {
        if (animationCallbackFunc != null) {
            animationCallbackFunc()
        }
    }
    function onAnimationFinished() {
        var kStarFactor = 360 * 3.1415926 / 180
        var fadeOutTime = 0.2
        bird.runAction(cc.Sequence.create(cc.Spawn.create(cc.ScaleTo.create(fadeOutTime, 2), cc.FadeOut.create(fadeOutTime)), cc.CallFunc.create(onLightAnimationEnd)))
        for (var i = 0; i <= 10; i += 1) {
            var fadeTime = 0.2 + math.random() * 0.3
            var angle = math.random() * kStarFactor
            var x = Math.cos(angle) * (80 + math.random() * 10)
            var y = Math.sin(angle) * (80 + math.random() * 10)
            var star = cc.Sprite.createWithSpriteFrameName("color_bird_star_1.png")
            star.setScale(1 + math.random())
            star.setPosition(ccp(math.random() * 15 - 8, math.random() * 15 - 8))
            star.runAction(cc.Spawn.create(cc.MoveTo.create(fadeTime, ccp(x, y)), cc.FadeOut.create(fadeTime)))
            container.addChild(star, 0)
        }
    }
    var halfTime = (time - 0.1) * 0.5
    bird.setOpacity(0)
    bird.runAction(cc.FadeIn.create(halfTime))
    var fadeArray = LuaArray.create()
    fadeArray.addObject(cc.Spawn.create(cc.ScaleTo.create(halfTime, 2, 1), cc.FadeIn.create(halfTime)))
    fadeArray.addObject(cc.DelayTime.create(0.1))
    fadeArray.addObject(cc.Spawn.create(cc.ScaleTo.create(halfTime, 2, 0), cc.FadeOut.create(halfTime)))
    sprite.setRotation(angle - 90)
    sprite.setScaleY(0)
    sprite.setOpacity(0)
    sprite.runAction(cc.Sequence.create(fadeArray.toLuaArray()))
    var array = LuaArray.create()
    array.addObject(cc.EaseSineInOut.create(cc.MoveTo.create(time, to)))
    array.addObject(cc.DelayTime.create(0.1))
    array.addObject(cc.CallFunc.create(onAnimationFinished))
    container.runAction(cc.Sequence.create(array.toLuaArray()))
    container.setPosition(from)
    container.addChild(bird)
    container.addChild(sprite)
    return container
}
// 新加的spine闪电动画
Firebolt.createSpineLight = function (from, to, color, duration, animationCallbackFunc) {
    let self = this
    duration = duration || 5 / 30
    let container = cc.Node.create()
    let spine = sp.SkeletonAnimation.create("flash/lightning.skel", "flash/txyh.atlas")
    spine.setPosition(from)
    container.addChild(spine)
    if (color === AnimalTypeConfig.kBlue) {
        spine.setSkin("hippo")
    } else if (color === AnimalTypeConfig.kGreen) {
        spine.setSkin("frog")
    } else if (color === AnimalTypeConfig.kOrange) {
        spine.setSkin("bear")
    } else if (color === AnimalTypeConfig.kPurple) {
        spine.setSkin("owl")
    } else if (color === AnimalTypeConfig.kRed) {
        spine.setSkin("fox")
    } else if (color === AnimalTypeConfig.kYellow) {
        spine.setSkin("chicken")
    }
    // 点亮spine
    let effectSpine = sp.SkeletonAnimation.create("flash/effect.skel", "flash/txyh.atlas")
    effectSpine.setPosition(to)
    container.addChild(effectSpine)
    effectSpine.setVisible(false)
    function onLightAnimationEnd() {
        container.unscheduleUpdate()
        container.runAction(cc.CallFunc.create(function () {
            if (animationCallbackFunc !== null) {
                animationCallbackFunc()
            }
        }))
    }
    let dx = to.x - from.x
    let dy = to.y - from.y
    let distance = dx * dx + dy * dy
    let angle = Math.atan2(dy, dx) * kRad3Ang
    spine.setRotation(-90 + angle)
    spine.setAnimation(0, "lightning", false)
    spine.registerSpineEventHandler(function (track) {
        // print(string.format("unscheduleUpdate %d nowLen %d dt %d", maxLen, nowLen, ut*GamePlayConfig_Action_FPS))
        spine.unregisterSpineEventHandler(3)
        onLightAnimationEnd()
    }, 3)
    let ut = 0
    let nowLen = 0
    let maxLen = Math.sqrt(distance)
    spine.setVisible(false)
    let moveBone = spine.findBone("move")
    moveBone.setY(0)
    container.onUpdate(function (dt) {
        ut = ut + dt
        if (ut > duration) {
            if (!effectSpine.isVisible()) {
                // 打到目标身上后，在目标处播放点亮动画
                effectSpine.setVisible(true)
                effectSpine.setAnimation(0, "effect", false)
            }
        }
        // 	print(string.format("flying %d nowLen %d dt %d", maxLen, nowLen, ut*GamePlayConfig_Action_FPS))
        nowLen = Math.min(maxLen, maxLen * ut / duration)
        moveBone.setY(-nowLen)
        spine.setVisible(true)
    }, 0)
    // container.scheduleUpdateWithPriorityLua(function (dt) {
      
    // }, 0)
    return container
}
BonusFlyingStar = xClass("BonusFlyingStar", function () {
    var fileName = "cocos/game_scene_bonus"
    FrameLoader.loadImageWithPlist(fileName + ".plist")
    return cc.Sprite.createWithSpriteFrameName("game_scene_bonus/bonus_time_bonus_flying_star1.png")
})
BonusFlyingStar.prototype.ctor = function (effectLayer) {
    var self = this
    self.startBuildStars(effectLayer)
}
BonusFlyingStar.prototype.startBuildStars = function (effectLayer) {
    var self = this
    function buildStar() {
        var fileName = "cocos/game_scene_bonus"
        FrameLoader.loadImageWithPlist(fileName + ".plist")
        var star = cc.Sprite.createWithSpriteFrameName("game_scene_bonus/bonus_time_bonus_flying_star2.png")
        star.setScale(math.random() * 0.4 + 0.6)
        var rad = self.getRotation() * Math.PI / 180
        star.runAction(cc.Sequence.create(cc.Spawn.create(cc.RotateBy.create(1.5, math.random() * 600 - 300), cc.FadeOut.create(0.8), cc.ScaleTo.create(1.2, 0), cc.EaseSineIn.create(cc.MoveBy.create(1.2, cc.p(-Math.sin(rad) * 50, -Math.cos(rad) * 50)))), cc.CallFunc.create(function () {
            star.removeFromParent(true)
        })))
        star.setPosition(cc.p(self.getPositionX() + math.random() * 20 - 10, self.getPositionY() + math.random() * 20 - 10))
        effectLayer.addChild(star)
    }
    function buildTrace() {
        var fileName = "cocos/game_scene_bonus"
        FrameLoader.loadImageWithPlist(fileName + ".plist")
        var particle = cc.Sprite.createWithSpriteFrameName("game_scene_bonus/bonus_time_bonus_flying_light_trace.png")
        particle.runAction(cc.Sequence.create(cc.FadeOut.create(0.5), cc.CallFunc.create(function () {
            particle.removeFromParent(true)
        })))
        particle.setRotation(self.getRotation())
        particle.setOpacity(120)
        particle.setPosition(cc.p(self.getPositionX(), self.getPositionY()))
        particle.setBlendFunc(table([1, "src", gl.ONE], [1, "dst", gl.ONE_MINUS_SRC_ALPHA]))
        effectLayer.addChild(particle)
    }
    self.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.DelayTime.create(0.01), cc.CallFunc.create(function () {
        buildStar()
    }))))
    self.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.DelayTime.create(1 / 30), cc.CallFunc.create(function () {
        buildTrace()
    }))))
}
CommonEffect.buildColorColorEffect = function (startBomb, endCallback) {
    var effectNode = cc.Node.create()
    effectNode.setPosition(360, 640)
    var timeSpendStartBomb = 0
    var timeSpendEndCallback = 0
    function buildLightNode() {
        var node = cc.Node.create()
        var args = table(
            [0, table(
                0.28,
                0.2,
                90,
                280,
                255
            )],
            [0, table(
                0.16,
                0.24,
                107,
                350,
                150
            )],
            [0, table(
                0.2,
                0.2,
                132,
                345,
                100
            )],
            [0, table(
                0.16,
                0.16,
                152,
                343,
                100
            )],
            [0, table(
                0.19,
                0.16,
                0,
                338,
                255
            )],
            [0, table(
                0.2,
                0.2,
                28,
                330,
                100
            )],
            [0, table(
                0.16,
                0.16,
                55,
                315,
                100
            )]
        )
        var $limit254 = $len(args)
        for (var i = 1; i <= $limit254; i += 1) {
            var color_bg_4 = cc.Sprite.createWithSpriteFrameName("color_bg_4.png")
            color_bg_4.setScale(args[i][1], args[i][2])
            color_bg_4.setOpacity(0)
            color_bg_4.setRotation(args[i][3])
            var actionList = table()
            table.insert(actionList, cc.DelayTime.create(50 / 30 - 13 / 30))
            table.insert(actionList, cc.Spawn.create(cc.RotateBy.create(27 / 30, args[i][4]), cc.FadeTo.create(14 / 30, args[i][5])))
            color_bg_4.runAction(cc.Sequence.create(actionList))
            node.addChild(color_bg_4)
        }
        return node
    }
    var color_bg_4_1 = buildLightNode()
    var action = cc.Sequence.create(cc.DelayTime.create(50 / 30 - 13 / 30), cc.Spawn.create(cc.ScaleTo.create(14 / 30, 11)), cc.CallFunc.create(function () {
        color_bg_4_1.removeFromParent(true)
    }))
    color_bg_4_1.runAction(action)
    effectNode.addChild(color_bg_4_1)
    var animName = "color_bg_6.png"
    var [offsetx, offsety] = [0, 0]
    var color_bg = cc.Sprite.createWithSpriteFrameName(animName)
    color_bg.setAnchorPoint(cc.p(0.5, 0.5))
    color_bg.setPosition(offsetx, offsety)
    color_bg.setOpacity(30)
    color_bg.setScale(260 / 144)
    var action = cc.Sequence.create(cc.Place.create(cc.p(offsetx, offsety)), cc.Spawn.create(cc.ScaleTo.create(7 / 30, 0.3), cc.FadeTo.create(7 / 30, 180)), cc.CallFunc.create(function () {
        color_bg.removeFromParent(true)
    }))
    color_bg.runAction(action)
    effectNode.addChild(color_bg)
    var animName = "bird_effect0000.png"
    var [offsetx, offsety] = [0, 0]
    var color_bg_2 = cc.Sprite.createWithSpriteFrameName(animName)
    color_bg_2.setOpacity(0)
    color_bg_2.setScale(230 / 109)
    var action = cc.Sequence.create(cc.Place.create(cc.p(offsetx, offsety)), cc.DelayTime.create(2 / 30), cc.Spawn.create(cc.ScaleTo.create(5 / 30, 1), cc.FadeTo.create(5 / 30, 200), cc.RotateBy.create(5 / 30, 60)), cc.CallFunc.create(function () {
        color_bg_2.removeFromParent(true)
    }))
    color_bg_2.runAction(action)
    effectNode.addChild(color_bg_2)
    var animName = "color_bg_3.png"
    var [offsetx, offsety] = [0, 0]
    var color_bg_3 = cc.Sprite.createWithSpriteFrameName(animName)
    color_bg_3.setAnchorPoint(cc.p(0.5, 0.5))
    color_bg_3.setPosition(offsetx, offsety)
    color_bg_3.setOpacity(0)
    color_bg_3.setScale(100 / 230)
    var action = cc.Sequence.create(cc.Place.create(cc.p(offsetx, offsety)), cc.DelayTime.create(16 / 30 - 13 / 30), cc.CallFunc.create(function () {
        color_bg_3.setOpacity(26)
    }), cc.Spawn.create(cc.ScaleTo.create(35 / 30, 350 / 230), cc.FadeTo.create(35 / 30, 200)), cc.CallFunc.create(function () {
        color_bg_3.removeFromParent(true)
    }))
    color_bg_3.runAction(action)
    effectNode.addChild(color_bg_3)
    var animName = "color_bg_3.png"
    var [offsetx, offsety] = [0, 0]
    var color_bg_3_2 = cc.Sprite.createWithSpriteFrameName(animName)
    color_bg_3_2.setAnchorPoint(cc.p(0.5, 0.5))
    color_bg_3_2.setPosition(offsetx, offsety)
    color_bg_3_2.setOpacity(0)
    color_bg_3_2.setScale(100 / 230)
    var actionList = table()
    table.insert(actionList, cc.Place.create(cc.p(offsetx, offsety)))
    table.insert(actionList, cc.DelayTime.create(16 / 30 - 13 / 30))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_bg_3_2.setOpacity(26)
    }))
    table.insert(actionList, cc.Spawn.create(cc.ScaleTo.create(20 / 30, 350 / 230), cc.FadeTo.create(20 / 30, 200)))
    for (var i = 1; i <= 6; i += 1) {
        table.insert(actionList, cc.DelayTime.create(1 / 30))
        table.insert(actionList, cc.CallFunc.create(function () {
            color_bg_3_2.setOpacity(230)
        }))
        table.insert(actionList, cc.DelayTime.create(1 / 30))
        table.insert(actionList, cc.CallFunc.create(function () {
            color_bg_3_2.setOpacity(160)
        }))
    }
    table.insert(actionList, cc.CallFunc.create(function () {
        color_bg_3_2.setOpacity(230)
    }))
    table.insert(actionList, cc.ScaleTo.create(8 / 30, 70 / 230))
    table.insert(actionList, cc.CallFunc.create(startBomb))
    table.insert(actionList, cc.ScaleTo.create(8 / 30, 350 / 230))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_bg_3_2.removeFromParent(true)
    }))
    var action = cc.Sequence.create(actionList)
    color_bg_3_2.runAction(action)
    effectNode.addChild(color_bg_3_2)
    timeSpendStartBomb = 16 / 30 - 13 / 30 + 20 / 30 + 12 / 30 + 8 / 30
    // var animName = "color_bg_5.png"
    // var color_bg_5 = cc.Sprite.createWithSpriteFrameName(animName)
    // color_bg_5.setVisible(false)
    // var action = cc.Sequence.create(cc.CallFunc.create(function () {
    //     color_bg_5.setVisible(false)
    // }), cc.DelayTime.create(63 / 30 - 13 / 30), cc.CallFunc.create(function () {
    //     color_bg_5.setVisible(true)
    // }), cc.Spawn.create(cc.ScaleTo.create(10 / 30, 4, 4), cc.FadeOut.create(10 / 30)), cc.CallFunc.create(function () {
    //     color_bg_5.removeFromParent(true)
    // }))
    // color_bg_5.runAction(action)
    // effectNode.addChild(color_bg_5)
    var animName = "color_bg_6.png"
    var color_bg_6 = cc.Sprite.createWithSpriteFrameName(animName)
    color_bg_6.setVisible(false)
    var action = cc.Sequence.create(cc.CallFunc.create(function () {
        color_bg_6.setVisible(false)
    }), cc.DelayTime.create(64 / 30 - 13 / 30), cc.CallFunc.create(function () {
        color_bg_6.setVisible(true)
    }), cc.Spawn.create(cc.ScaleTo.create(12 / 30, 4.56, 4.56), cc.FadeOut.create(12 / 30)), cc.CallFunc.create(function () {
        color_bg_6.removeFromParent(true)
    }))
    color_bg_6.runAction(action)
    effectNode.addChild(color_bg_6)
    // function buildStar() {
    //     var node = cc.Node.create()
    //     var args = table(
    //         [0, table(
    //             [0, -5],
    //             15,
    //             0.88,
    //             175,
    //             15
    //         )],
    //         [0, table(
    //             [0, -5],
    //             15,
    //             1.2,
    //             58,
    //             270
    //         )],
    //         [0, table(
    //             [0, -30],
    //             31,
    //             1.6,
    //             [0, -188],
    //             330
    //         )],
    //         [0, table(
    //             [0, -20],
    //             17,
    //             1.1,
    //             [0, -197],
    //             175
    //         )],
    //         [0, table(
    //             [0, -23],
    //             2,
    //             0.9,
    //             [0, -175],
    //             105
    //         )],
    //         [0, table(
    //             [0, -17],
    //             20,
    //             1.4,
    //             [0, -300],
    //             50
    //         )],
    //         [0, table(
    //             [0, -40],
    //             [0, -11],
    //             1.9,
    //             [0, -333],
    //             [0, -195]
    //         )],
    //         [0, table(
    //             [0, -30],
    //             7,
    //             1.1,
    //             [0, -160],
    //             [0, -175]
    //         )],
    //         [0, table(
    //             [0, -20],
    //             [0, -12],
    //             0.7,
    //             [0, -15],
    //             [0, -160]
    //         )],
    //         [0, table(
    //             2,
    //             40,
    //             1.1,
    //             215,
    //             [0, -119]
    //         )],
    //         [0, table(
    //             25,
    //             [0, -23],
    //             1.4,
    //             300,
    //             64
    //         )],
    //         [0, table(
    //             43,
    //             12,
    //             1.7,
    //             170,
    //             330
    //         )],
    //         [0, table(
    //             0,
    //             45,
    //             1,
    //             6,
    //             250
    //         )]
    //     )
    //     var $limit293 = $len(args)
    //     for (var i = 1; i <= $limit293; i += 1) {
    //         var color_bg_7 = cc.Sprite.createWithSpriteFrameName("color_bg_7.png")
    //         color_bg_7.setPosition(args[i][1], args[i][2])
    //         color_bg_7.setScale(args[i][3])
    //         color_bg_7.setRotation(math.random(1, 90))
    //         color_bg_7.setVisible(false)
    //         var actionList = table()
    //         table.insert(actionList, cc.CallFunc.create(function () {
    //             color_bg_7.setVisible(false)
    //         }))
    //         table.insert(actionList, cc.DelayTime.create(63 / 30 - 13 / 30))
    //         table.insert(actionList, cc.CallFunc.create(function () {
    //             color_bg_7.setVisible(true)
    //         }))
    //         table.insert(actionList, cc.Spawn.create(cc.RotateBy.create(50 / 30, math.random(180, 500)), cc.FadeOut.create(50 / 30), cc.ScaleTo.create(50 / 30, 0.1), cc.MoveTo.create(50 / 30, cc.p(args[i][4] * 1.5, args[i][5] * 1.5))))
    //         color_bg_7.runAction(cc.Sequence.create(actionList))
    //         node.addChild(color_bg_7)
    //     }
    //     return node
    // }
    // var color_bg_7_1 = buildStar()
    // var actionList = table()
    // for (var i = 1; i <= 40; i += 1) {
    //     table.insert(actionList, cc.DelayTime.create(0.05))
    //     table.insert(actionList, cc.CallFunc.create(function () {
    //         color_bg_7_1.setVisible(false)
    //     }))
    //     table.insert(actionList, cc.DelayTime.create(0.05))
    //     table.insert(actionList, cc.CallFunc.create(function () {
    //         color_bg_7_1.setVisible(true)
    //     }))
    // }
    // color_bg_7_1.runAction(cc.Spawn.create(cc.Sequence.create(actionList), cc.Sequence.create(cc.DelayTime.create(120 / 30 - 13 / 30 - 15 / 30), cc.CallFunc.create(function () {
    //     color_bg_7_1.removeFromParent(true)
    // }))))
    // effectNode.addChild(color_bg_7_1)
    // var color_bg_7_2 = buildStar()
    // color_bg_7_2.setRotation(180)
    // var actionList = table()
    // for (var i = 1; i <= 40; i += 1) {
    //     table.insert(actionList, cc.DelayTime.create(0.05))
    //     table.insert(actionList, cc.CallFunc.create(function () {
    //         color_bg_7_2.setVisible(false)
    //     }))
    //     table.insert(actionList, cc.DelayTime.create(0.05))
    //     table.insert(actionList, cc.CallFunc.create(function () {
    //         color_bg_7_2.setVisible(true)
    //     }))
    // }
    // color_bg_7_2.runAction(cc.Spawn.create(cc.Sequence.create(actionList), cc.Sequence.create(cc.DelayTime.create(120 / 30 - 13 / 30 - 15 / 30), cc.CallFunc.create(function () {
    //     color_bg_7_2.removeFromParent(true)
    //     endCallback()
    // }))))
    // effectNode.addChild(color_bg_7_2)
    timeSpendEndCallback = Math.max(timeSpendEndCallback, 120 / 30 - 13 / 30 - 15 / 30)
    return [effectNode, timeSpendStartBomb, timeSpendEndCallback]
}
CommonEffect.buildBirdBG = function () {
    var effectNode = cc.Node.create()
    var color_animal_bg_1 = cc.Sprite.createWithSpriteFrameName("color_animal_bg_1.png")
    effectNode.addChild(color_animal_bg_1)
    var actionList = table()
    table.insert(actionList, cc.DelayTime.create(11 / 30))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_1.removeFromParent(true)
    }))
    color_animal_bg_1.runAction(cc.Sequence.create(actionList))
    var color_animal_bg_2 = cc.Sprite.createWithSpriteFrameName("color_animal_bg_2.png")
    color_animal_bg_2.setOpacity(26)
    color_animal_bg_2.setVisible(false)
    effectNode.addChild(color_animal_bg_2)
    var actionList = table()
    table.insert(actionList, cc.DelayTime.create(11 / 30))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_2.setVisible(true)
    }))
    var scaleAction = table()
    table.insert(scaleAction, cc.CallFunc.create(function () {
        color_animal_bg_2.setScale(383 / 325)
    }))
    table.insert(scaleAction, cc.ScaleTo.create(20 / 30, 50 / 325))
    table.insert(actionList, cc.Repeat.create(cc.Sequence.create(scaleAction), 4))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_2.setScale(383 / 325)
    }))
    table.insert(actionList, cc.Spawn.create(cc.ScaleTo.create(8 / 30, 0.5), cc.FadeOut.create(8 / 30)))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_2.removeFromParent(true)
    }))
    color_animal_bg_2.runAction(cc.Sequence.create(actionList))
    var color_animal_bg_3 = cc.Sprite.createWithSpriteFrameName("color_animal_bg_3.png")
    color_animal_bg_3.setVisible(false)
    effectNode.addChild(color_animal_bg_3)
    var actionList = table()
    table.insert(actionList, cc.DelayTime.create(11 / 30))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_3.setVisible(true)
    }))
    var scaleAction = table()
    table.insert(scaleAction, cc.CallFunc.create(function () {
        color_animal_bg_3.setScale(150 / 98)
    }))
    table.insert(scaleAction, cc.Sequence.create(cc.ScaleTo.create(10 / 30, 227 / 98), cc.ScaleTo.create(10 / 30, 150 / 98)))
    table.insert(actionList, cc.Spawn.create(cc.FadeIn.create(10 / 30), cc.Repeat.create(cc.Sequence.create(scaleAction), 4)))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_3.setScale(200 / 98)
    }))
    table.insert(actionList, cc.Spawn.create(cc.ScaleTo.create(8 / 30, 0.8), cc.FadeOut.create(8 / 30)))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_3.removeFromParent(true)
    }))
    color_animal_bg_3.runAction(cc.Sequence.create(actionList))
    var color_animal_bg_4 = cc.Sprite.createWithSpriteFrameName("color_animal_bg_4.png")
    color_animal_bg_4.setVisible(false)
    effectNode.addChild(color_animal_bg_4)
    color_animal_bg_4.runAction(cc.RepeatForever.create(cc.RotateBy.create(8 / 30, 50)))
    var actionList = table()
    table.insert(actionList, cc.DelayTime.create(11 / 30))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_4.setVisible(true)
        color_animal_bg_4.setScale(47 / 163)
    }))
    table.insert(actionList, cc.Spawn.create(cc.FadeIn.create(8 / 30), cc.ScaleTo.create(8 / 30, 238 / 163)))
    table.insert(actionList, cc.DelayTime.create(71 / 30))
    table.insert(actionList, cc.ScaleTo.create(7 / 30, 263 / 163))
    table.insert(actionList, cc.Spawn.create(cc.ScaleTo.create(6 / 30, 195 / 163), cc.FadeOut.create(6 / 30)))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_4.removeFromParent(true)
    }))
    color_animal_bg_4.runAction(cc.Sequence.create(actionList))
    var color_animal_bg_5 = cc.Sprite.createWithSpriteFrameName("color_animal_bg_5.png")
    color_animal_bg_5.setVisible(false)
    effectNode.addChild(color_animal_bg_5)
    color_animal_bg_5.runAction(cc.RepeatForever.create(cc.RotateBy.create(20 / 30, 50)))
    var actionList = table()
    table.insert(actionList, cc.DelayTime.create(11 / 30))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_5.setVisible(true)
        color_animal_bg_5.setScale(114 / 192)
    }))
    table.insert(actionList, cc.Spawn.create(cc.FadeIn.create(8 / 30), cc.ScaleTo.create(8 / 30, 282 / 192)))
    table.insert(actionList, cc.DelayTime.create(71 / 30))
    table.insert(actionList, cc.ScaleTo.create(7 / 30, 373 / 192))
    table.insert(actionList, cc.Spawn.create(cc.ScaleTo.create(10 / 30, 238 / 192), cc.FadeOut.create(10 / 30)))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_5.removeFromParent(true)
    }))
    color_animal_bg_5.runAction(cc.Sequence.create(actionList))
    var color_animal_bg_6 = cc.Sprite.createWithSpriteFrameName("color_animal_bg_6.png")
    color_animal_bg_6.setVisible(false)
    effectNode.addChild(color_animal_bg_6)
    color_animal_bg_6.runAction(cc.RepeatForever.create(cc.RotateBy.create(15 / 30, 50)))
    var actionList = table()
    table.insert(actionList, cc.DelayTime.create(11 / 30))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_6.setVisible(true)
        color_animal_bg_6.setScale(260 / 180)
    }))
    table.insert(actionList, cc.Spawn.create(cc.FadeIn.create(5 / 30)))
    table.insert(actionList, cc.DelayTime.create(74 / 30))
    table.insert(actionList, cc.ScaleTo.create(5 / 30, 345 / 180))
    table.insert(actionList, cc.Spawn.create(cc.ScaleTo.create(11 / 30, 220 / 192), cc.FadeOut.create(11 / 30)))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_6.removeFromParent(true)
    }))
    color_animal_bg_6.runAction(cc.Sequence.create(actionList))
    var color_animal_bg_7 = cc.Sprite.createWithSpriteFrameName("color_animal_bg_7.png")
    color_animal_bg_7.setVisible(false)
    color_animal_bg_7.setScale(260 / 172)
    effectNode.addChild(color_animal_bg_7)
    var actionList = table()
    table.insert(actionList, cc.DelayTime.create(96 / 30))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_7.setVisible(true)
    }))
    table.insert(actionList, cc.ScaleTo.create(4 / 30, 222 / 172))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_7.removeFromParent(true)
    }))
    color_animal_bg_7.runAction(cc.Sequence.create(actionList))
    var color_animal_bg_2_2 = cc.Sprite.createWithSpriteFrameName("color_animal_bg_2.png")
    color_animal_bg_2_2.setVisible(false)
    color_animal_bg_2_2.setScale(319 / 325)
    effectNode.addChild(color_animal_bg_2_2)
    var actionList = table()
    table.insert(actionList, cc.DelayTime.create(100 / 30))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_2_2.setVisible(true)
    }))
    table.insert(actionList, cc.Spawn.create(cc.ScaleTo.create(8 / 30, 450 / 325), cc.FadeOut.create(8 / 30)))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_2_2.removeFromParent(true)
    }))
    color_animal_bg_2_2.runAction(cc.Sequence.create(actionList))
    var color_animal_bg_9 = cc.Sprite.createWithSpriteFrameName("color_animal_bg_9.png")
    color_animal_bg_9.setVisible(false)
    color_animal_bg_9.setScale(100 / 100)
    effectNode.addChild(color_animal_bg_9)
    var actionList = table()
    table.insert(actionList, cc.DelayTime.create(95 / 30))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_9.setVisible(true)
    }))
    table.insert(actionList, cc.Spawn.create(cc.ScaleTo.create(7 / 30, 40 / 100), cc.FadeOut.create(7 / 30)))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_9.removeFromParent(true)
    }))
    color_animal_bg_9.runAction(cc.Sequence.create(actionList))
    var color_animal_bg_8 = cc.Sprite.createWithSpriteFrameName("color_animal_bg_8.png")
    color_animal_bg_8.setVisible(false)
    effectNode.addChild(color_animal_bg_8)
    var actionList = table()
    table.insert(actionList, cc.DelayTime.create(12 / 30))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_8.setVisible(true)
    }))
    var scaleAction = table()
    table.insert(scaleAction, cc.CallFunc.create(function () {
        color_animal_bg_8.setScale(306 / 203)
    }))
    table.insert(scaleAction, cc.Sequence.create(cc.ScaleTo.create(14 / 30, 250 / 203), cc.ScaleTo.create(14 / 30, 306 / 203)))
    table.insert(actionList, cc.Spawn.create(cc.FadeIn.create(5 / 30), cc.Repeat.create(cc.Sequence.create(scaleAction), 4)))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_8.setScale(224 / 203)
    }))
    table.insert(actionList, cc.Spawn.create(cc.ScaleTo.create(7 / 30, 60 / 203), cc.FadeOut.create(7 / 30)))
    table.insert(actionList, cc.CallFunc.create(function () {
        color_animal_bg_8.removeFromParent(true)
    }))
    color_animal_bg_8.runAction(cc.Sequence.create(actionList))
    return effectNode
}
CommonEffect.buildSuperEffect = function () {
    var effectNode = cc.Node.create()
    var effect_color_light = cc.Sprite.createWithSpriteFrameName("effect_color_light.png")
    effect_color_light.setPosition(3, -5)
    effect_color_light.setOpacity(90)
    effectNode.addChild(effect_color_light)
    var actionList = table()
    table.insert(actionList, cc.CallFunc.create(function () {
        effect_color_light.setScale(383 / 161)
    }))
    table.insert(actionList, cc.EaseSineInOut.create(cc.ScaleTo.create(20 / 30, 0.9)))
    effect_color_light.runAction(cc.RepeatForever.create(cc.Sequence.create(actionList)))
    var effect_color_bg = cc.Sprite.createWithSpriteFrameName("effect_super_bird_bg.png")
    effectNode.addChild(effect_color_bg)
    var actionList = table()
    table.insert(actionList, cc.RotateBy.create(10 / 30, 35))
    effect_color_bg.runAction(cc.RepeatForever.create(cc.Sequence.create(actionList)))
    var effect_color_fg = cc.Sprite.createWithSpriteFrameName("effect_super_bird_fg.png")
    effect_color_fg.setScale(50 / 260)
    effectNode.addChild(effect_color_fg)
    effect_color_fg.runAction(cc.RepeatForever.create(cc.RotateBy.create(5 / 30, 35)))
    var actionList = table()
    table.insert(actionList, cc.ScaleTo.create(5 / 30, 1))
    effect_color_fg.runAction(cc.Sequence.create(actionList))
    var starAndLineNode = cc.Node.create()
    effectNode.addChild(starAndLineNode)
    starAndLineNode.setPosition(0, 0)
    starAndLineNode.setCascadeOpacityEnabled(true)
    var lines = table()
    for (var i = 0; i <= 5; i += 1) {
        var line = CommonEffect.buildLines("effect_super_bird_line.png")
        line.setRotation(i * 60)
        starAndLineNode.addChild(line)
        table.insert(lines, line)
    }
    var effectStars = table()
    for (var i = 0; i <= 5; i += 1) {
        var effectStar = CommonEffect.buildStarEffect("effect_super_bird_star.png")
        effectStar.setRotation(i * 60)
        starAndLineNode.addChild(effectStar)
        table.insert(effectStars, effectStar)
    }
    function onEnd() {
        function build() {
            var stars = CommonEffect.buildBombStars("effect_super_bird_star.png")
            effectNode.addChild(stars)
        }
        var actionList = table()
        var scale = effect_color_light.getScale()
        var time = 0.1
        table.insert(actionList, cc.Spawn.create(cc.ScaleTo.create(time, 0.9), cc.FadeTo.create(time, 160)))
        table.insert(actionList, cc.Spawn.create(cc.ScaleTo.create(12 / 30, 3), cc.FadeOut.create(12 / 30), cc.CallFunc.create(build)))
        table.insert(actionList, cc.RemoveSelf.create())
        effect_color_light.stopAllActions()
        effect_color_light.runAction(cc.Sequence.create(actionList))
        var actionList = table()
        table.insert(actionList, cc.ScaleTo.create(5 / 30, 1.3))
        table.insert(actionList, cc.Spawn.create(cc.ScaleTo.create(10 / 30, 0.8), cc.FadeOut.create(10 / 30)))
        table.insert(actionList, cc.RemoveSelf.create())
        effect_color_bg.runAction(cc.Sequence.create(actionList))
        var actionList = table()
        table.insert(actionList, cc.DelayTime.create(2 / 30))
        table.insert(actionList, cc.ScaleTo.create(3 / 30, 1.3))
        table.insert(actionList, cc.Spawn.create(cc.ScaleTo.create(10 / 30, 0.8), cc.FadeOut.create(10 / 30)))
        table.insert(actionList, cc.RemoveSelf.create())
        effect_color_fg.runAction(cc.Sequence.create(actionList))
        starAndLineNode.runAction(cc.Sequence.create(cc.FadeOut.create(time), cc.RemoveSelf.create()))
        effectNode.runAction(cc.Sequence.create(cc.DelayTime.create(5), cc.CallFunc.create(function () {
            effectNode.removeFromParent(true)
        })))
    }
    // effectNode:runAction(cc.Sequence:create(cc.DelayTime:create(3),cc.CallFunc:create(onEnd)))
    effectNode.setCascadeOpacityEnabled(true)
    effectNode.setOpacity(0)
    effectNode.runAction(cc.FadeIn.create(0.3))
    effectNode.onEnd = onEnd
    return effectNode
}
CommonEffect.buildColorEffect = function () {
    var effectNode = cc.Node.create()
    var effect_color_light = cc.Sprite.createWithSpriteFrameName("effect_color_light.png")
    effect_color_light.setPosition(3, -5)
    effect_color_light.setOpacity(90)
    effectNode.addChild(effect_color_light)
    var actionList = table()
    table.insert(actionList, cc.CallFunc.create(function () {
        effect_color_light.setScale(383 / 161)
    }))
    table.insert(actionList, cc.EaseSineInOut.create(cc.ScaleTo.create(20 / 30, 0.9)))
    effect_color_light.runAction(cc.RepeatForever.create(cc.Sequence.create(actionList)))
    var effect_color_bg = cc.Sprite.createWithSpriteFrameName("effect_color_bg.png")
    effectNode.addChild(effect_color_bg)
    var actionList = table()
    table.insert(actionList, cc.RotateBy.create(10 / 30, 50))
    effect_color_bg.runAction(cc.RepeatForever.create(cc.Sequence.create(actionList)))
    var effect_color_fg = cc.Sprite.createWithSpriteFrameName("effect_color_fg.png")
    effect_color_fg.setScale(50 / 260)
    effectNode.addChild(effect_color_fg)
    effect_color_fg.runAction(cc.RepeatForever.create(cc.RotateBy.create(5 / 30, 50)))
    var actionList = table()
    table.insert(actionList, cc.ScaleTo.create(5 / 30, 1))
    effect_color_fg.runAction(cc.Sequence.create(actionList))
    var lines = table()
    for (var i = 0; i <= 5; i += 1) {
        var line = CommonEffect.buildLines("effect_color_line.png")
        line.setRotation(i * 60)
        effectNode.addChild(line)
        table.insert(lines, line)
    }
    var effectStars = table()
    for (var i = 0; i <= 5; i += 1) {
        var effectStar = CommonEffect.buildStarEffect("effect_color_star.png")
        effectStar.setRotation(i * 60)
        effectNode.addChild(effectStar)
        table.insert(effectStars, effectStar)
    }
    function onEnd() {
        function build() {
            var stars = CommonEffect.buildBombStars("effect_color_star.png")
            effectNode.addChild(stars)
        }
        var actionList = table()
        var scale = effect_color_light.getScale()
        var time = 0.1
        table.insert(actionList, cc.Spawn.create(cc.ScaleTo.create(time, 0.9), cc.FadeTo.create(time, 160)))
        table.insert(actionList, cc.Spawn.create(cc.ScaleTo.create(12 / 30, 3), cc.FadeOut.create(12 / 30), cc.CallFunc.create(build)))
        table.insert(actionList, cc.CallFunc.create(function () {
            effect_color_light.removeFromParent(true)
        }))
        effect_color_light.stopAllActions()
        effect_color_light.runAction(cc.Sequence.create(actionList))
        var actionList = table()
        table.insert(actionList, cc.ScaleTo.create(5 / 30, 1.3))
        table.insert(actionList, cc.Spawn.create(cc.ScaleTo.create(10 / 30, 0.8), cc.FadeOut.create(10 / 30)))
        table.insert(actionList, cc.CallFunc.create(function () {
            effect_color_bg.removeFromParent(true)
        }))
        effect_color_bg.runAction(cc.Sequence.create(actionList))
        var actionList = table()
        table.insert(actionList, cc.DelayTime.create(2 / 30))
        table.insert(actionList, cc.ScaleTo.create(3 / 30, 1.3))
        table.insert(actionList, cc.Spawn.create(cc.ScaleTo.create(10 / 30, 0.8), cc.FadeOut.create(10 / 30)))
        table.insert(actionList, cc.CallFunc.create(function () {
            effect_color_fg.removeFromParent(true)
        }))
        effect_color_fg.runAction(cc.Sequence.create(actionList))
        for (var k in effectStars) {
            let v = effectStars[k]
            var actionList = table()
            table.insert(actionList, cc.FadeOut.create(time))
            table.insert(actionList, cc.CallFunc.create(function () {
                v.removeFromParent(true)
            }))
            v.runAction(cc.Sequence.create(actionList))
        }
        for (var k in lines) {
            let v = lines[k]
            var actionList = table()
            table.insert(actionList, cc.FadeOut.create(time))
            table.insert(actionList, cc.CallFunc.create(function () {
                v.removeFromParent(true)
            }))
            v.runAction(cc.Sequence.create(actionList))
        }
        effectNode.runAction(cc.Sequence.create(cc.DelayTime.create(5), cc.CallFunc.create(function () {
            effectNode.removeFromParent(true)
        })))
    }
    // effectNode:runAction(cc.Sequence:create(cc.DelayTime:create(3),cc.CallFunc:create(onEnd)))
    var children = effectNode.getChildren()
    for (var k in children) {
        var v = children[k]
        v.setOpacity(0)
        v.runAction(cc.FadeIn.create(0.3))
    }
    effectNode.onEnd = onEnd
    return effectNode
}
CommonEffect.buildStarEffect = function (name) {
    //x, y, scale, alpha
    var frames = $len(CommonEffectConfig.offsets_star[1])
    var effectNode = cc.Node.create()
    var stars = table()
    var frame_cur = 1
    for (var k in CommonEffectConfig.offsets_star) {
        var v = CommonEffectConfig.offsets_star[k]
        stars[k] = cc.Sprite.createWithSpriteFrameName(name)
        effectNode.addChild(stars[k])
    }
    for (var k in stars) {
        var v = stars[k]
        var data = CommonEffectConfig.offsets_star[k][frame_cur]
        v.setPosition(data[1], data[2])
        v.setScale(data[3] * 0.8)
        v.setOpacity(data[4] * 0.85)
    }
    function call() {
        for (var k in stars) {
            var v = stars[k]
            var data = CommonEffectConfig.offsets_star[k][frame_cur]
            v.setPosition(data[1], data[2])
            v.setScale(data[3] * 0.8)
            v.setOpacity(data[4] * 0.85)
        }
        frame_cur = frame_cur + 1
        if (frame_cur > frames) {
            frame_cur = 1
        }
    }
    var actionList = table()
    table.insert(actionList, cc.DelayTime.create(1 / 30))
    table.insert(actionList, cc.CallFunc.create(call))
    effectNode.runAction(cc.RepeatForever.create(cc.Sequence.create(actionList)))
    return effectNode
}
CommonEffect.buildBombStars = function (name) {
    //x, y, scale, alpha
    var frames = $len(CommonEffectConfig.bomb_stars[1])
    var effectNode = cc.Node.create()
    var stars = table()
    var frame_cur = 1
    for (var k in CommonEffectConfig.bomb_stars) {
        var v = CommonEffectConfig.bomb_stars[k]
        stars[k] = cc.Sprite.createWithSpriteFrameName(name)
        effectNode.addChild(stars[k])
    }
    for (var k in stars) {
        var v = stars[k]
        var data = CommonEffectConfig.bomb_stars[k][frame_cur]
        v.setPosition(data[1], data[2])
        v.setScale(data[3] * 0.6)
        v.setOpacity(data[4] * 0.6)
    }
    function call() {
        for (var k in stars) {
            var v = stars[k]
            var data = CommonEffectConfig.bomb_stars[k][frame_cur]
            v.setPosition(data[1], data[2])
            v.setScale(data[3] * 0.6)
            v.setOpacity(data[4] * 0.6)
        }
        frame_cur = frame_cur + 1
        if (frame_cur > frames) {
            frame_cur = 1
        }
    }
    var actionList = table()
    table.insert(actionList, cc.DelayTime.create(1 / 30))
    table.insert(actionList, cc.CallFunc.create(call))
    function onEnd() {
        for (var k in stars) {
            var v = stars[k]
            v.stopAllActions()
            v.removeFromParent(true)
        }
    }
    effectNode.runAction(cc.Sequence.create(cc.Repeat.create(cc.Sequence.create(actionList), frames), cc.CallFunc.create(onEnd)))
    return effectNode
}
CommonEffect.buildLines = function (name) {
    //x, y, scale, alpha
    var frames = $len(CommonEffectConfig.lines_offset[1])
    var effectNode = cc.Node.create()
    var linesps = table()
    var frame_cur = 1
    for (var k in CommonEffectConfig.lines_offset) {
        var v = CommonEffectConfig.lines_offset[k]
        var line = cc.Node.create()
        line.setRotation(k * 15)
        effectNode.addChild(line)
        var linesp = cc.Sprite.createWithSpriteFrameName(name)
        linesp.setAnchorPoint(cc.p(25 / 87, 40 / 104))
        line.addChild(linesp)
        linesps[k] = linesp
    }
    for (var k in linesps) {
        var v = linesps[k]
        var data = CommonEffectConfig.lines_offset[k][frame_cur]
        v.setPosition(data[1], data[2])
        v.setScale(data[3])
        v.setOpacity(data[4] * 0.6)
        v.setRotation(data[5])
    }
    function call() {
        for (var k in linesps) {
            var v = linesps[k]
            var data = CommonEffectConfig.lines_offset[k][frame_cur]
            v.setPosition(data[1], data[2])
            v.setScale(data[3])
            v.setOpacity(data[4] * 0.6)
            v.setRotation(data[5])
        }
        frame_cur = frame_cur + 1
        if (frame_cur > frames) {
            frame_cur = 1
        }
    }
    var actionList = table()
    table.insert(actionList, cc.DelayTime.create(1 / 30))
    table.insert(actionList, cc.CallFunc.create(call))
    effectNode.runAction(cc.RepeatForever.create(cc.Sequence.create(actionList)))
    return effectNode
}
CommonEffect.playColorSwapWithSuperBird = function (view, callback) {
    callback && callback()
    return 0
    var scene = cc.Director.getInstance().getRunningScene()
    var size = cc.Director.getInstance().getWinSize()
    var layerColor = cc.LayerColor.create(cc.c4b(0, 0, 0, 255))
    layerColor.setContentSize(size)
    layerColor.setOpacity(0)
    scene.addChild(layerColor, 9999)
    var container = cc.Node.create()
    var pos_x = 80
    var pos_y = 0
    container.setPosition(size.width / 2 + pos_x - GamePlayConfig_Design_Width / 2, size.height / 2 + pos_y - GamePlayConfig_Design_Height / 2)
    var names = table(
        "cocos/super_bird_color_swap_star_swap_star.csb",
        [0, cc.p(25, 1280 - 408)],
        0,
        1,
        "cocos/super_bird_color_swap_flash_star.csb",
        [0, cc.p(225 - 40, 1280 - 266)],
        [0, 25 / 30],
        1,
        "cocos/super_bird_color_swap_bear_bearhit.csb",
        [0, cc.p(517 - 35, 1280 - 314)],
        0,
        0.55,
        "cocos/super_bird_color_swap_chicken_chickhit.csb",
        [0, cc.p(-28 - 50, 1280 - 394)],
        0,
        0.7
    )
    var nodes = table()
    function create(i) {
        var name = names[i * 4 + 1]
        var pos = names[i * 4 + 2]
        var time = names[i * 4 + 3]
        var scale = names[i * 4 + 4]
        var node = cc.CSLoader.createNode(name)
        var actionTimeLine = cc.CSLoader.createTimeline(name)
        node.actionTimeLine = actionTimeLine
        node.runAction(actionTimeLine)
        actionTimeLine.gotoFrameAndPlay(0, false)
        node.setScale(scale)
        node.setPosition(pos)
        container.addChild(node, 9999)
        nodes[i] = node
    }
    for (var i = 0; i <= 3; i += 1) {
        create(i)
    }
    function clean() {
        for (var k in nodes) {
            var v = nodes[k]
            v.removeFromParent(true)
        }
        layerColor.removeFromParent(true)
        container.removeFromParent(true)
        if (callback) {
            callback()
        }
    }
    var actionList = table()
    table.insert(actionList, cc.FadeTo.create(5 / 30, 200))
    table.insert(actionList, cc.DelayTime.create(47 / 30))
    table.insert(actionList, cc.FadeOut.create(3 / 30))
    table.insert(actionList, cc.CallFunc.create(clean))
    layerColor.runAction(cc.Sequence.create(actionList))
    scene.addChild(container, 9999)
    return (5 + 47 + 3) / 30
}
CommonEffect.playSuperBirdSwapWithSuperBird = function (view, callback) {
    callback && callback()
    return 0
    var scene = cc.Director.getInstance().getRunningScene()
    var size = cc.Director.getInstance().getWinSize()
    var layerColor = cc.LayerColor.create(cc.c4b(0, 0, 0, 255))
    layerColor.setContentSize(size)
    layerColor.setOpacity(0)
    scene.addChild(layerColor, 9999)
    var container = cc.Node.create()
    container.setScale(0.88)
    var pos_x = 110
    var pos_y = 1280 - 732 - 35
    container.setPosition(size.width / 2 + pos_x - GamePlayConfig_Design_Width / 2, size.height / 2 + pos_y - GamePlayConfig_Design_Height / 2)
    var names = table(
        "cocos/super_bird_super_bird_swap_star_star.csb",
        [0, cc.p(-2, 1280 - 513)],
        0,
        1,
        "cocos/super_bird_super_bird_swap_chicken_chicken.csb",
        [0, cc.p(-344, 84)],
        0,
        0.62,
        "cocos/super_bird_super_bird_swap_cat_cat.csb",
        [0, cc.p(-184, -134)],
        0,
        0.55,
        "cocos/super_bird_super_bird_swap_bear_bear.csb",
        [0, cc.p(-80, -90)],
        0,
        0.53,
        "cocos/super_bird_super_bird_swap_frog_frog.csb",
        [0, cc.p(53, -44 - 50)],
        0,
        0.55,
        "cocos/super_bird_super_bird_swap_boat_boat.csb",
        [0, cc.p(-267 + 250, -94 + 20)],
        0,
        1,
        "cocos/super_bird_super_bird_swap_spray_spray.csb",
        [0, cc.p(-300 - 50, -28 - 60)],
        0,
        1,
        "cocos/super_bird_super_bird_swap_water_water.csb",
        [0, cc.p(429, -197)],
        0,
        1.07
    )
    var nodes = table()
    function create(i) {
        var name = names[i * 4 + 1]
        var pos = names[i * 4 + 2]
        var time = names[i * 4 + 3]
        var scale = names[i * 4 + 4]
        var node = cc.CSLoader.createNode(name)
        var actionTimeLine = cc.CSLoader.createTimeline(name)
        node.actionTimeLine = actionTimeLine
        node.runAction(actionTimeLine)
        actionTimeLine.gotoFrameAndPlay(0, false)
        node.setScale(scale)
        node.setPosition(pos)
        if (0 === i) {
            // view:getShowPanel(ItemSpriteType.kSpecial):addChild(node, 9999)
            var pos_x = pos.x
            var pos_y = pos.y
            node.setPosition(size.width / 2 + pos_x - GamePlayConfig_Design_Width / 2, size.height / 2 + pos_y - GamePlayConfig_Design_Height / 2)
            scene.addChild(node, 9999)
        } else {
            if (7 === i) { }
            container.addChild(node, 9999)
        }
        nodes[i] = node
    }
    for (var i = 0; i <= 7; i += 1) {
        create(i)
    }
    var spray = nodes[6]
    var times = table(
        [0, 30 / 30],
        [0, 5 / 30],
        [0, 3 / 30],
        [0, 2 / 30],
        [0, 1 / 30],
        [0, 30 / 30]
    )
    for (var j = 1; j <= 6; j += 1) {
        var child = spray.getChildByName("waterflower" + j)
        child.setVisible(false)
        child.stopAllActions()
        function callEnd() {
            child.setVisible(false)
            child.stopAllActions()
        }
        function call() {
            child.setVisible(true)
            var action = cc.CSLoader.createTimeline("cocos/super_bird_super_bird_swap_spray_waterflower1.csb")
            child.runAction(action)
            action.gotoFrameAndPlay(0, false)
        }
        layerColor.runAction(cc.Sequence.create(cc.DelayTime.create(times[j]), cc.CallFunc.create(call), cc.DelayTime.create(22 / 30), cc.CallFunc.create(callEnd)))
    }
    var child = nodes[7]
    child.setVisible(false)
    child.stopAllActions()
    function callEnd() {
        child.setVisible(false)
        child.stopAllActions()
    }
    function call() {
        child.setVisible(true)
        var action = cc.CSLoader.createTimeline("cocos/super_bird_super_bird_swap_water_water.csb")
        action.setTimeSpeed(0.8)
        child.runAction(action)
        action.gotoFrameAndPlay(0, false)
    }
    layerColor.runAction(cc.Sequence.create(cc.DelayTime.create(17 / 30), cc.CallFunc.create(call), cc.DelayTime.create(39 / 30), cc.CallFunc.create(callEnd)))
    function clean() {
        for (var k in nodes) {
            var v = nodes[k]
            v.removeFromParent(true)
        }
        layerColor.removeFromParent(true)
        container.removeFromParent(true)
        callback()
    }
    var actionList = table()
    table.insert(actionList, cc.FadeTo.create(5 / 30, 200))
    table.insert(actionList, cc.DelayTime.create(57 / 30))
    table.insert(actionList, cc.FadeOut.create(3 / 30))
    table.insert(actionList, cc.CallFunc.create(clean))
    layerColor.runAction(cc.Sequence.create(actionList))
    scene.addChild(container, 9999)
    return 65 / 30
}
//-----------------------------------------------
//只在指定消除关和地块收集关生效
//前置， ObjectPool, AnimationCachePool
//----------------------------------------------
CommonEffect.getFlyTailAction = function (time, zOrder) {
    var isTail = true
    if (AnimationCachePool.getInstance().isFlyTailFull() || __use_low_effect) {
        isTail = false
    }
    zOrder = zOrder || 0
    var duration = 0.06
    var times = Math.max(Math.floor(time / duration) - 2, 1)
    var count = 0
    var last
    function createStars(target) {
        count = count + 1
        var sp = ObjectPool.getInstance().get("OrderTargetTail")
        function over() {
            sp.removeFromParent(true)
            ObjectPool.getInstance().collect("OrderTargetTail", sp)
            if (count >= times) {
                AnimationCachePool.getInstance().decFlyTailCount()
            }
        }
        sp.play(AnimationCachePool.getInstance().getFrameAnimate("OrderTargetTailAnimate"), 0, 1, over)
        var {x, y} = target.getPosition()
        var offsetX = 0
        if (count < times / 2) {
            offsetX = math.random(30) - 15
        }
        x = x + offsetX
        sp.setPosition(x, y)
        if (!last) {
            last = cc.p(x, y)
        }
        var ang = Math.atan2(x - last.x, y - last.y)
        sp.setAnchorPoint(cc.p(0.5, 1))
        sp.setRotation(math.deg(ang))
        var rate = Math.abs(count - times / 2) / times * 2
        var scale = (1 - rate) * 0.5 + 0.5
        if (count > times / 2) {
            // sp:setScale(scale)
            sp.setOpacity(((1 - rate) * 0.5 + 0.5) * 255)
        } else {
            // sp:setScale(1)
            sp.setOpacity(255)
        }
        sp.setScale((0.5 * (times - count) / times) + 0.5)
        var parent = target.getParent()
        parent.addChild(sp, zOrder)
    }
    var tail_action
    if (isTail) {
        AnimationCachePool.getInstance().addFlyTailCount()
        tail_action = cc.Repeat.create(cc.Sequence.create(cc.CallFunc.create(createStars), cc.DelayTime.create(duration)), times)
    }
    return tail_action
}
CommonEffect.hintAnimation4IceMOde = function (mainLogic, callback, needClean) {
    let self = this
    let scene = cc.Director.getInstance().getRunningScene()
    let layerColor = cc.LayerColor.create(cc.c4b(0, 0, 0, 0))
    layerColor.changeWidthAndHeight(display.width, display.height)
    scene.addChild(layerColor, 99999)
    layerColor.onTouch(function () {
        return true
    }, false, true)
    table.insert(needClean, layerColor)
    let boardView = mainLogic.boardView
    let subTileContainer = cc.Node.create()
    boardView.addChild(subTileContainer, 99999)
    table.insert(needClean, subTileContainer)
    function onEnd() {
        layerColor.removeFromParent(true)
        subTileContainer.removeFromParent(true)
        if (type(callback) === "function") {
            callback()
        }
    }
    function onAnimEnd() {
        boardView.hideMask()
        layerColor.runAction(cc.Sequence.create(cc.DelayTime.create(0.5), cc.CallFunc.create(onEnd)))
    }
    function buildFrameNode(seaAnimalConfig) {
        let widthHalf = seaAnimalConfig.width * GamePlayConfig_Tile_Width / 2
        let heightHalf = seaAnimalConfig.height * GamePlayConfig_Tile_Height / 2
        let scale = seaAnimalConfig.width * seaAnimalConfig.height > 3 && 1 || 0.667
        let node = cc.Node.create()
        node.setCascadeOpacityEnabled(true)
        let rotations = table(
            [0, -90],
            0,
            180,
            90
        )
        for (let i = 1; i <= 4; i += 1) {
            let frame = cc.Sprite.createWithSpriteFrameName("sea_animal_tip_frame.png")
            frame.setAnchorPoint(cc.p(1, 1))
            frame.setRotation(rotations[i])
            frame.setScale(scale)
            frame.setPosition((1 - i % 2 * 2) * widthHalf, (i > 2 && -1 || 1) * heightHalf)
            node.addChild(frame)
        }
        node.setPosition((seaAnimalConfig.c - 1) * GamePlayConfig_Tile_Width + widthHalf, (GamePlayConfig_Max_Item_Y - seaAnimalConfig.r) * GamePlayConfig_Tile_Width - heightHalf)
        return node
    }
    let excludeTable = table()
    let seaAnimals = mainLogic.getSeaAnimal()
    let temp = table()
    for (let k in seaAnimals) {
        let v = seaAnimals[k]
        if ($null(v)) continue
        if (v.seaAnimalType >= GameItemDefMapKey.kSoda_1_2 && v.seaAnimalType <= GameItemDefMapKey.kSoda_2_1 || v.seaAnimalType >= GameItemDefMapKey.kSoda_1_2_symmetry && v.seaAnimalType <= GameItemDefMapKey.kSoda_2_1_symmetry) { } else {
            table.insert(temp, v)
        }
    }
    seaAnimals = temp
    for (let k in seaAnimals) {
        let v = seaAnimals[k]
        if ($null(v)) continue
        let $var513 = v.r,$limit514 = v.r + v.height - 1
        for (let i = $var513; i <= $limit514; i += 1) {
            let $var516 = v.c,$limit517 = v.c + v.width - 1
            for (let j = $var516; j <= $limit517; j += 1) {
                table.insert(excludeTable, table([1, "r", i], [1, "c", j]))
            }
        }
    }
    boardView.showMask(excludeTable)
    for (let k in seaAnimals) {
        let v = seaAnimals[k]
        if ($null(v)) continue
        let node = buildFrameNode(v)
        node.setOpacity(50)
        node.setScale(1.2)
        subTileContainer.addChild(node)
        let actionList = table()
        let act = table()
        table.insert(act, cc.EaseSineIn.create(cc.ScaleTo.create(7 / 30, 1)))
        table.insert(act, cc.EaseSineIn.create(cc.FadeTo.create(7 / 30, 255)))
        table.insert(actionList, cc.Spawn.create(act))
        table.insert(actionList, cc.DelayTime.create(38 / 30))
        table.insert(actionList, cc.FadeOut.create(11 / 30))
        node.runAction(cc.Sequence.create(actionList))
    }
    let node = cc.Node.create()
    subTileContainer.addChild(node)
    let actionList = table()
    table.insert(actionList, cc.DelayTime.create(10 / 30))
    table.insert(actionList, cc.EaseSineOut.create(cc.MoveTo.create(6 / 30, cc.p(100, 0))))
    table.insert(actionList, cc.CallFunc.create(function () {
        node.setPositionX(0)
    }))
    table.insert(actionList, cc.EaseSineInOut.create(cc.MoveTo.create(6 / 30, cc.p(100, 0))))
    node.runAction(cc.Sequence.create(actionList))
    for (let k in seaAnimals) {
        let v = seaAnimals[k]
        if ($null(v)) continue
        let widthHalf = v.width * GamePlayConfig_Tile_Width / 2
        let heightHalf = v.height * GamePlayConfig_Tile_Height / 2
        let [rotation, anchorPoint, image, scale, offset] = TileSeaAnimal.prototype.getSpriteConfig(v.seaAnimalType)
        scale = scale && scale || 1
        offset = offset && offset || cc.p(0, 0)
        let seaAnimal = cc.Sprite.createWithSpriteFrameName(image)
        seaAnimal.setAnchorPoint(cc.p(0.5, 0.5))
        seaAnimal.setRotation(rotation)
        seaAnimal.setScale(scale)
        seaAnimal.setPosition((v.c - 1) * GamePlayConfig_Tile_Width + widthHalf, (GamePlayConfig_Max_Item_Y - v.r) * GamePlayConfig_Tile_Width - heightHalf)
        subTileContainer.addChild(seaAnimal)
        seaAnimal.setOpacity(0)
        let actionList = table()
        table.insert(actionList, cc.FadeTo.create(15 / 30, 190))
        table.insert(actionList, cc.DelayTime.create(26 / 30))
        table.insert(actionList, cc.FadeOut.create(7 / 30))
        seaAnimal.runAction(cc.Sequence.create(actionList))
        let actionList2 = table()
        table.insert(actionList2, cc.DelayTime.create(10 / 30))
        table.insert(actionList2, cc.EaseSineOut.create(cc.ScaleTo.create(6 / 30, 1.1)))
        table.insert(actionList2, cc.EaseSineInOut.create(cc.ScaleTo.create(6 / 30, 0.9)))
        table.insert(actionList2, cc.EaseSineInOut.create(cc.ScaleTo.create(5 / 30, 1.05)))
        table.insert(actionList2, cc.EaseSineOut.create(cc.ScaleTo.create(4 / 30, 1)))
        seaAnimal.runAction(cc.Sequence.create(actionList2))
        let actionList3 = table()
        table.insert(actionList3, cc.DelayTime.create(10 / 30))
        table.insert(actionList3, cc.Repeat.create(cc.Sequence.create(cc.DelayTime.create(1 / 30), cc.CallFunc.create(function () {
            let value = node.getPositionX() / 100
            seaAnimal.setGroupRenderPass(0, "advanced_color", table([1, "u_rate", table(
                    1,
                    1,
                    1,
                    1
                )], [1, "u_delta", table(
                    0,
                    [0, value * 14 / 255],
                    [0, value * 35 / 255],
                    [0, value * 50 / 255]
                )]))
        })), 12))
        table.insert(actionList3, cc.CallFunc.create(function () {
            seaAnimal.setGroupRenderPass(0, "advanced_color", table([1, "u_rate", table(
                    1,
                    1,
                    1,
                    1
                )], [1, "u_delta", table(
                    0,
                    0,
                    0,
                    0
                )]))
        }))
        seaAnimal.runAction(cc.Sequence.create(actionList3))
    }
    let allLayers = table(
        [0, ItemSpriteType.kSeaAnimal],
        [0, ItemSpriteType.kLight],
        [0, ItemSpriteType.kItem],
        [0, ItemSpriteType.kItemShow],
        [0, ItemSpriteType.kFlowerVineLink],
        [0, ItemSpriteType.kShell],
        [0, ItemSpriteType.kDiamond],
        [0, ItemSpriteType.kFurBall],
        [0, ItemSpriteType.kLock]
    )
    let allItemRCs = table()
    for (let k in seaAnimals) {
        let v = seaAnimals[k]
        if ($null(v)) continue
        let $var542 = v.r,$limit543 = v.r + v.height - 1
        for (let i = $var542; i <= $limit543; i += 1) {
            let $var545 = v.c,$limit546 = v.c + v.width - 1
            for (let j = $var545; j <= $limit546; j += 1) {
                table.insert(allItemRCs, table([1, "r", i], [1, "c", j]))
            }
        }
    }
    for (let k in allItemRCs) {
        let v = allItemRCs[k]
        if ($null(v)) continue
        let itemView = boardView.baseMap[v.r][v.c]
        for (let kk in allLayers) {
            let vv = allLayers[kk]
            if ($null(vv)) continue
            if (itemView.itemSprite[vv]) {
                itemView.itemSprite[vv].setCascadeOpacityEnabled(true)
                let $st553 = itemView.itemSprite[vv].getChildren()
                for (let kkk in $st553) {
                    let vvv = $st553[kkk]
                    if ($null(vvv)) continue
                    vvv.setCascadeOpacityEnabled(true)
                }
                if (v === ItemSpriteType.kLight) {
                    let actionList = table()
                    table.insert(actionList, cc.FadeTo.create(14 / 30, 150))
                    table.insert(actionList, cc.DelayTime.create(27 / 30))
                    table.insert(actionList, cc.FadeIn.create(15 / 30))
                    itemView.itemSprite[vv].runAction(cc.Sequence.create(actionList))
                } else {
                    let actionList = table()
                    table.insert(actionList, cc.FadeTo.create(14 / 30, 80))
                    table.insert(actionList, cc.DelayTime.create(27 / 30))
                    table.insert(actionList, cc.FadeIn.create(15 / 30))
                    itemView.itemSprite[vv].runAction(cc.Sequence.create(actionList))
                }
            }
        }
    }
    layerColor.runAction(cc.Sequence.create(cc.DelayTime.create(45 / 30), cc.CallFunc.create(onAnimEnd)))
}
CommonEffect.showHintAnimation4IceMode = function (mainLogic, callback) {
    let self = this
    let needClean = table()
    let [result, _] = pcall(function () {
        CommonEffect.hintAnimation4IceMOde(mainLogic, callback, needClean)
    })
    if (!result) {
        for (let k in needClean) {
            let v = needClean[k]
            if ($null(v)) continue
            v.removeFromParent(true)
        }
        if (type(callback) === "function") {
            callback()
        }
    }
}

CommonEffect.scoreParticleEffectNum = 0
CommonEffect.scoreEffectNum = 0
CommonEffect.buildGetScoreStarAnim = function (stat, end, parent) {
    if (CommonEffect.scoreEffectNum > Quality.kScoreStarMaxNum || cc.Director.getInstance().getAvgFrameRate() < Quality.kFPSGuardLine) {
        return
    }
    var endp = end
    var start = stat
    var sep = cc.p(endp.x - start.x, endp.y - start.y)
    // var dis = Math.max(cc.pGetLength(sep) - 60, 0)
    var dis = cc.pGetLength(sep) - 60
    var rota = cc.pToAngleSelf(sep)
    var degree = -rota * 180 / 3.14 - 90
    var clen = 0
    var idx = 0
    do  {
        var cp = cc.p(clen * Math.cos(rota) + start.x, clen * Math.sin(rota) + start.y)
        if (clen + 60 >= dis) {
            clen = dis - 10
        }else {
            clen = clen + 60
        }
        var tp = cc.p(clen * Math.cos(rota) + start.x, clen * Math.sin(rota) + start.y)
        CommonEffect.createScorePartical(cp, tp, degree, idx * 0.04, parent)
        if (idx === 4 || idx === 7) {
            CommonEffect.createScoreStar(cp, tp, degree, idx * 0.04, parent)
        }
        idx = idx + 1
    } while (!(clen >= dis - 15 || CommonEffect.scoreParticleEffectNum > Quality.kScoreParticleMaxNum))
}

CommonEffect.createScorePartical =function (pos, target, rotation, delay, parent) {
    CommonEffect.scoreParticleEffectNum = CommonEffect.scoreParticleEffectNum + 1
    var sprite = ObjectPool.getInstance().get("ScoreParticle")
    sprite.setAnchorPoint(ccp(0.5, 0))
    sprite.setPosition(pos)
    sprite.setRotation(rotation)
    sprite.setScale(math.random(90, 220) / 100)
    sprite.setGlobalZOrder(100)
    sprite.runAction(cc.Sequence.create(cc.Hide.create(), cc.DelayTime.create(delay), cc.Show.create(), cc.CallFunc.create(function () {
        var frames = SpriteUtil.buildFrames("gameScene/score_particle_%04d.png", 1, 20)
        var animate = SpriteUtil.buildAnimate(frames, 1 / 30)
        sprite.play(animate, 0, 1, function () {
            CommonEffect.scoreParticleEffectNum = CommonEffect.scoreParticleEffectNum - 1
            sprite.removeFromParent(true)
            ObjectPool.getInstance().collect("ScoreParticle", sprite)
        })
        sprite.runAction(cc.MoveTo.create(0.3, target))
    })))
    parent.addChild(sprite)
}

CommonEffect.createScoreStar = function (pos, target, rotation, delay, parent) {
    CommonEffect.scoreEffectNum = CommonEffect.scoreEffectNum + 1
    var sprite = ObjectPool.getInstance().get("ScoreStarParticle")
    sprite.setPosition(pos)
    sprite.setRotation(rotation)
    sprite.setScale(0.8)
    sprite.setGlobalZOrder(100)
    sprite.runAction(cc.Sequence.create(cc.Hide.create(), cc.DelayTime.create(delay), cc.Show.create(), cc.CallFunc.create(function () {
        var starframes = SpriteUtil.buildFrames("gameScene/score_star_%04d.png", 0, 20)
        var animate = SpriteUtil.buildAnimate(starframes, kCharacterAnimationTime)
        sprite.play(animate, 0, 1, function () {
            CommonEffect.scoreEffectNum = CommonEffect.scoreEffectNum - 1
            sprite.removeFromParent(true)
            ObjectPool.getInstance().collect("ScoreStarParticle", sprite)
        })
        sprite.runAction(cc.MoveTo.create(0.2, target))
    })))
    parent.addChild(sprite)
}